/*Developed by Gevorg Manukyan, Araks Yepremyan */
var GMMD5={};GMMD5.MD5=function(r){function i(r,n){return r<<n|r>>>32-n}function C(r,n){var t,o,e,u,a;return e=2147483648&r,u=2147483648&n,a=(1073741823&r)+(1073741823&n),(t=1073741824&r)&(o=1073741824&n)?2147483648^a^e^u:t|o?1073741824&a?3221225472^a^e^u:1073741824^a^e^u:a^e^u}function n(r,n,t,o,e,u,a){var f;return C(i(r=C(r,C(C((f=n)&t|~f&o,e),a)),u),n)}function t(r,n,t,o,e,u,a){var f;return C(i(r=C(r,C(C(n&(f=o)|t&~f,e),a)),u),n)}function o(r,n,t,o,e,u,a){return C(i(r=C(r,C(C(n^t^o,e),a)),u),n)}function e(r,n,t,o,e,u,a){return C(i(r=C(r,C(C(t^(n|~o),e),a)),u),n)}function u(r){var n,t="",o="";for(n=0;n<=3;n++)t+=(o="0"+(r>>>8*n&255).toString(16)).substr(o.length-2,2);return t}var a,f,c,g,h,v,d,S,l,m=Array();for(m=function(r){for(var n,t=r.length,o=t+8,e=16*((o-o%64)/64+1),u=Array(e-1),a=0,f=0;f<t;)a=f%4*8,u[n=(f-f%4)/4]=u[n]|r.charCodeAt(f)<<a,f++;return a=f%4*8,u[n=(f-f%4)/4]=u[n]|128<<a,u[e-2]=t<<3,u[e-1]=t>>>29,u}(r=function(r){r=r.replace(/\r\n/g,"\n");for(var n="",t=0;t<r.length;t++){var o=r.charCodeAt(t);o<128?n+=String.fromCharCode(o):(127<o&&o<2048?n+=String.fromCharCode(o>>6|192):(n+=String.fromCharCode(o>>12|224),n+=String.fromCharCode(o>>6&63|128)),n+=String.fromCharCode(63&o|128))}return n}(r)),v=1732584193,d=4023233417,S=2562383102,l=271733878,a=0;a<m.length;a+=16)d=e(d=e(d=e(d=e(d=o(d=o(d=o(d=o(d=t(d=t(d=t(d=t(d=n(d=n(d=n(d=n(c=d,S=n(g=S,l=n(h=l,v=n(f=v,d,S,l,m[a+0],7,3614090360),d,S,m[a+1],12,3905402710),v,d,m[a+2],17,606105819),l,v,m[a+3],22,3250441966),S=n(S,l=n(l,v=n(v,d,S,l,m[a+4],7,4118548399),d,S,m[a+5],12,1200080426),v,d,m[a+6],17,2821735955),l,v,m[a+7],22,4249261313),S=n(S,l=n(l,v=n(v,d,S,l,m[a+8],7,1770035416),d,S,m[a+9],12,2336552879),v,d,m[a+10],17,4294925233),l,v,m[a+11],22,2304563134),S=n(S,l=n(l,v=n(v,d,S,l,m[a+12],7,1804603682),d,S,m[a+13],12,4254626195),v,d,m[a+14],17,2792965006),l,v,m[a+15],22,1236535329),S=t(S,l=t(l,v=t(v,d,S,l,m[a+1],5,4129170786),d,S,m[a+6],9,3225465664),v,d,m[a+11],14,643717713),l,v,m[a+0],20,3921069994),S=t(S,l=t(l,v=t(v,d,S,l,m[a+5],5,3593408605),d,S,m[a+10],9,38016083),v,d,m[a+15],14,3634488961),l,v,m[a+4],20,3889429448),S=t(S,l=t(l,v=t(v,d,S,l,m[a+9],5,568446438),d,S,m[a+14],9,3275163606),v,d,m[a+3],14,4107603335),l,v,m[a+8],20,1163531501),S=t(S,l=t(l,v=t(v,d,S,l,m[a+13],5,2850285829),d,S,m[a+2],9,4243563512),v,d,m[a+7],14,1735328473),l,v,m[a+12],20,2368359562),S=o(S,l=o(l,v=o(v,d,S,l,m[a+5],4,4294588738),d,S,m[a+8],11,2272392833),v,d,m[a+11],16,1839030562),l,v,m[a+14],23,4259657740),S=o(S,l=o(l,v=o(v,d,S,l,m[a+1],4,2763975236),d,S,m[a+4],11,1272893353),v,d,m[a+7],16,4139469664),l,v,m[a+10],23,3200236656),S=o(S,l=o(l,v=o(v,d,S,l,m[a+13],4,681279174),d,S,m[a+0],11,3936430074),v,d,m[a+3],16,3572445317),l,v,m[a+6],23,76029189),S=o(S,l=o(l,v=o(v,d,S,l,m[a+9],4,3654602809),d,S,m[a+12],11,3873151461),v,d,m[a+15],16,530742520),l,v,m[a+2],23,3299628645),S=e(S,l=e(l,v=e(v,d,S,l,m[a+0],6,4096336452),d,S,m[a+7],10,1126891415),v,d,m[a+14],15,2878612391),l,v,m[a+5],21,4237533241),S=e(S,l=e(l,v=e(v,d,S,l,m[a+12],6,1700485571),d,S,m[a+3],10,2399980690),v,d,m[a+10],15,4293915773),l,v,m[a+1],21,2240044497),S=e(S,l=e(l,v=e(v,d,S,l,m[a+8],6,1873313359),d,S,m[a+15],10,4264355552),v,d,m[a+6],15,2734768916),l,v,m[a+13],21,1309151649),S=e(S,l=e(l,v=e(v,d,S,l,m[a+4],6,4149444226),d,S,m[a+11],10,3174756917),v,d,m[a+2],15,718787259),l,v,m[a+9],21,3951481745),v=C(v,f),d=C(d,c),S=C(S,g),l=C(l,h);return(u(v)+u(d)+u(S)+u(l)).toLowerCase()};


CheckCountry();



/*! device.js 0.1.58 */
(function(){var a,b,c,d,e,f,g,h,i,j;a=window.device,window.device={},c=window.document.documentElement,j=window.navigator.userAgent.toLowerCase(),device.ios=function(){return device.iphone()||device.ipod()||device.ipad()},device.iphone=function(){return d("iphone")},device.ipod=function(){return d("ipod")},device.ipad=function(){return d("ipad")},device.android=function(){return d("android")},device.androidPhone=function(){return device.android()&&d("mobile")},device.androidTablet=function(){return device.android()&&!d("mobile")},device.blackberry=function(){return d("blackberry")||d("bb10")||d("rim")},device.blackberryPhone=function(){return device.blackberry()&&!d("tablet")},device.blackberryTablet=function(){return device.blackberry()&&d("tablet")},device.windows=function(){return d("windows")},device.windowsPhone=function(){return device.windows()&&d("phone")},device.windowsTablet=function(){return device.windows()&&d("touch")},device.fxos=function(){return(d("(mobile;")||d("(tablet;"))&&d("; rv:")},device.fxosPhone=function(){return device.fxos()&&d("mobile")},device.fxosTablet=function(){return device.fxos()&&d("tablet")},device.meego=function(){return d("meego")},device.mobile=function(){return device.androidPhone()||device.iphone()||device.ipod()||device.windowsPhone()||device.blackberryPhone()||device.fxosPhone()||device.meego()},device.tablet=function(){return device.ipad()||device.androidTablet()||device.blackberryTablet()||device.windowsTablet()||device.fxosTablet()},device.portrait=function(){return 90!==Math.abs(window.orientation)},device.landscape=function(){return 90===Math.abs(window.orientation)},device.noConflict=function(){return window.device=a,this},d=function(a){return-1!==j.indexOf(a)},f=function(a){var b;return b=new RegExp(a,"i"),c.className.match(b)},b=function(a){return f(a)?void 0:c.className+=" "+a},h=function(a){return f(a)?c.className=c.className.replace(a,""):void 0},device.ios()?device.ipad()?b("ios ipad tablet"):device.iphone()?b("ios iphone mobile"):device.ipod()&&b("ios ipod mobile"):device.android()?device.androidTablet()?b("android tablet"):b("android mobile"):device.blackberry()?device.blackberryTablet()?b("blackberry tablet"):b("blackberry mobile"):device.windows()?device.windowsTablet()?b("windows tablet"):device.windowsPhone()?b("windows mobile"):b("desktop"):device.fxos()?device.fxosTablet()?b("fxos tablet"):b("fxos mobile"):device.meego()?b("meego mobile"):b("desktop"),e=function(){return device.landscape()?(h("portrait"),b("landscape")):(h("landscape"),b("portrait"))},i="onorientationchange"in window,g=i?"orientationchange":"resize",window.addEventListener?window.addEventListener(g,e,!1):window.attachEvent?window.attachEvent(g,e):window[g]=e,e()}).call(this);



var _ajaxloadingpageid=2;
var _ajaxloadpresspage=2;
var _productslistshow=1;
var _loadingcollectionproducts=true;
var show_more_height;
var animateTime = 500;

var vimeoiframe;
var vimeoplayer;
var _canayaxload=true;
var document_width, document_height;

var __shop_social=[];
var _shop_social_corusel;

var _story_corusel;

function removePadding(){
	/*var scroll_pos = $(window).scrollTop() + $(window).height();
	$('.list_block').each(function(){
    	var element_pos = $(this).offset().top;
    	if (scroll_pos > element_pos+100) {
    		__this = $(this);
		    __this.find('.category_block').removeClass('padding');
	    };
    });*/

    var scroll_pos = $(window).scrollTop() + $(window).height();
  	$('.list_block').first().addClass('animation-end');
	$('.list_block').each(function(){
    	var element_pos = $(this).offset().top;
    	if (scroll_pos > element_pos+$(this).height()/3) {
		    $(this).addClass('animation-end');
	    };
    });
}

function removeScale(){
	var scroll_pos = $(window).scrollTop() + $(window).height();
	$('.scaled').each(function(){
    	var element_pos = $(this).offset().top;
    	if (scroll_pos > element_pos) {
    		__this = $(this);
		    __this.removeClass('scaled');
	    };
    });
}

function autoHeightAnimate(element, time){
  	var curHeight = element.height(),
        autoHeight = element.css('height', 'auto').innerHeight();
	element.innerHeight(curHeight);
    element.stop().animate({ height: autoHeight }, time);
}

function autoHeightOpacityAnimate(element, time){
  	var curHeight = element.height(),
        autoHeight = element.css('height', 'auto').innerHeight();
	element.innerHeight(curHeight);
  	element.stop().animate({ height: autoHeight, opacity: 1 }, time);
}


function paralaxCollectionBanners(){
	var elem = $('.parallax_height');
	var wheight=$(window).height();
	var scrolling = $(window).scrollTop();
	 elem.each(function(){
        var $this = $(this);
		var offset = $this.offset().top;
		var height = $this.height();
		var transform = 0;
		if(scrolling+wheight>=offset) {
			transform=Math.round(((wheight+height)-((offset+height)-scrolling))/((wheight+height)/100));
			if(scrolling>=(offset+height)){
				transform=100;
			}
		}
		$this.find('.parallax_blocks').css({'background-position': 'center ' + transform + '%'});
	});	
}

$(window).on("load", function() {
    if($('.category_block').length && $('.list_block').length){
		removePadding();
	}
	if($('.scaled').length){
		removeScale();
	}
  
  
  	if(!$('body').hasClass('page-index')){
      scrollCb();
    }
});

function scrollCb() {
  	var tiles = $(".category_block:not(.animated):not(.cat_description)");
    var $window = $(window);
    var b = $window.scrollTop() + $window.height();

  	tiles.first().addClass("animated faster").addClass("slideInUpCustom");
  
    tiles.each(function (i) {
        var $this = $(this);
      
      	if(window.innerWidth > 640){
        	var a = $this.offset().top + $this.height()/3;
        }
        else{
          var a = $this.offset().top + $this.height()/4;
        }

        if (a < b) {
            $this.addClass("animated faster").addClass("slideInUpCustom");
        }
    });
}

function hashchangeSupport(){
  var hash = window.location.hash.substring(1);
  
  if(hash=="privacy-c"){
    hash="privacy";
    setTimeout(function(){
   	 	var targetOffset = $('.prvc_id_8').offset().top-50;
		$('html, body').animate({scrollTop: targetOffset}, 1000);
    }, 1000);
  } else if(hash=="manuals"){
    location.href = "https://www.seikowatches.com/us-en/customerservice/instruction";
  }
  
  $('.support_tab_block').removeClass('active');
  $('.support_tab_block.'+hash).addClass('active');
  
  
  
  $('.offscreen').attr('href', '#'+hash);
  
  $('.support_tab_block.faq a').attr('tabindex', '-1');
  $('.support_tab_block a[target="_blank"]').attr('aria-label', 'opens in new window');
  
  
  $('.support_tab_block').removeClass('active').attr('state', 'collapsed').attr('aria-hidden', 'true');
  $('.support_tab_block.'+hash).addClass('active').attr('state', 'expanded').attr('aria-hidden', 'false');
  
  
  if($('.support_tabs .support_tab[data-tab="'+hash+'"]').length){
    $('.support_tab').removeClass('active').attr('state', 'closed').attr('aria-expanded', 'false').attr('aria-selected', 'false');;
    $('.support_tab[data-tab="'+hash+'"]').addClass('active').attr('state', 'opened').attr('aria-expanded', 'true').attr('aria-selected', 'true');
  } else if(hash=='shipping'){
     $('.support_tab').removeClass('active').attr('state', 'closed').attr('aria-expanded', 'false').attr('aria-selected', 'false');;
     $('.support_tab[data-tab="privacy"]').addClass('active').attr('state', 'opened').attr('aria-expanded', 'true').attr('aria-selected', 'true');
     $('.support_tab_block.privacy').addClass('active').addClass('active').attr('state', 'expanded').attr('aria-hidden', 'false');
     $("html, body").animate({ scrollTop: $(document).height()-$(window).height() });
  } else{
    $('.support_tab[data-tab="service"]').addClass('active').attr('state', 'opened').attr('aria-expanded', 'true').attr('aria-selected', 'true');
  }
  
  if(window.innerWidth <= 640){
	$('.support_tab').first().attr('data-tab', $('.support_tab.active').attr('data-tab')).html($('.support_tab.active').html());
  }
}


var _allmanuals={};
function LoadManuals(){
	$.ajax({
		type: "GET",
		url: _products_manuals_json_url,
        dataType:'json'
	}).done(function(_manuals) {
		_allmanuals=_manuals;
	}).fail(function(e) {
		console.loog(e);
	});
}
////////////////////////////////////////////////////////////////////////
function SearchManuals(_val){
  $('.download_manual').css('display','none');
  $('.no_manual_found').css('display','none');
  var _findmanual=false;
  for(var _key in _allmanuals) { 
     for(var _v=0;_v<_allmanuals[_key].length;_v++) { 
       if(_allmanuals[_key][_v].toLowerCase()==_val.toLowerCase()){
         $('.download_manual').html('DOWNLOAD MANUAL');
         $('.download_manual').attr('href', "http://loremipsumcorp.com/seiko_shopify_data/watch-manuals/"+_key+".pdf");
         $('.download_manual').css('display','block').focus();
         _findmanual=true;
          break;
       }
     }
     if(_findmanual) break;  
  }
  if(!_findmanual){
    $('.no_manual_found').css('display','block');
  }
}

function supportTabs(__this){
  $('.support_tab').removeClass('active').attr('state', 'closed').attr('aria-expanded', 'false').attr('aria-selected', 'false');
  __this.addClass('active').attr('state', 'opened').attr('aria-expanded', 'true').attr('aria-selected', 'true');

  $('.support_tab_block').removeClass('active').attr('state', 'collapsed').attr('aria-hidden', 'true');
  var indexTab = __this.data('tab');
  $('.support_tab_block.'+indexTab).addClass('active').addClass('active').attr('state', 'expanded').attr('aria-hidden', 'false');
  contentHeight();
  history.pushState({},  '', "#"+indexTab);
  $('.offscreen').attr('href', '#'+indexTab);

  $('.manuals_form')[0].reset();
  $('.download_manual').css('display','none');
  $('.no_manual_found').css('display','none');
}



var xDown = null;                                                        
var yDown = null;

function getTouches(evt) {
  return evt.touches ||             // browser API
         evt.originalEvent.touches; // jQuery
}                                                     

function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];                                      
    xDown = firstTouch.clientX;                                      
    yDown = firstTouch.clientY;                                      
};                                                

function handleTouchMove(evt) {
    if ( ! xDown || ! yDown ) {
        return;
    }

    var xUp = evt.touches[0].clientX;                                    
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
        if ( xDiff > 0 ) {
          if($('.product_thumb.active').next().hasClass('product_thumb')){
              $('.photo_zoom').html('<img src="'+$('.photo_zoom').attr('data-spin')+'" alt="" title="" class="spinner" />');
              $(document).find('.photo_zoom').css('background-image', 'none');
              $('.zoom_shadow').hide();
              setTimeout(function(){
                $('.product_thumb.active').next().trigger('click');
              }, 500);  
          }
        } else {
          if($('.product_thumb.active').prev().hasClass('product_thumb')){
              $('.photo_zoom').html('<img src="'+$('.photo_zoom').attr('data-spin')+'" alt="" title="" class="spinner" />');
              $(document).find('.photo_zoom').css('background-image', 'none');
              $('.zoom_shadow').hide();
              setTimeout(function(){
                $('.product_thumb.active').prev().trigger('click');
              }, 500);
          }
        }                       
    } else {
        if ( yDiff > 0 ) {
            /* up swipe */ 
        } else { 
            /* down swipe */
        }                                                                 
    }
    /* reset values */
    xDown = null;
    yDown = null;                                             
};


$(document).ready(function() {
  
    /*if($('.collections_section.product_section').length){
      if($('.collections_section.product_section .product_block').length == 1){
        $('.filters_all').hide();
        $('.collections_section.product_section').css('padding-top', '40px');
      }
    }*/
  
    if($('.prod_feat_desc')[0])$('.prod_feat_desc').append('<a href="https://seiko-luxe.herokuapp.com/getpdf/'+meta.product.variants[0].sku.toLowerCase()+'" target="_blank" class="standard_button product_features_btn_pdf">DOWNLOAD PRODUCT SPECIFICATIONS</a>');
  
  
    $(window).resize(function() {
      if(window.innerWidth < 640){
        if($('.catalog_top_image.parallax_height').length){
          if(!$('.catalog_top_image.parallax_height .parallax_bg').hasClass('video_viewport')){
            $('.catalog_top_image').css('padding-bottom', '100%');
          }
        }
      }
    }).trigger('resize');
  
  
  
    $('.find_a_store').on('click', function(e){
      if(window.innerWidth > 640){
        e.preventDefault();
        $(".l_map_res_list").empty();
        $('.store_popup_block h2 span').show();
        $('.find_a_store_opened').stop().animate({"height": 200}, 400);
        $(this).addClass('active');
      }
      else{
        window.location.href = '/pages/store-locator';
      }
    });
    $('.findstore.popup_close').on('click', function(){
      $('.find_a_store_opened').stop().animate({"height": 0}, 400);
      $(this).removeClass('active');
    });

    $('.loc_fixed').on('click', function(){
      $(".l_map_res_list").empty();
      L_GeoIP_popup();
    });

    $('#praddress_incollection').keypress(function (e) {
      if (e.which == 13) {
        ///searchLocations(); 
      }
    });		

    $("#praddress_incollection").keyup(function() {
        var _data = $(this).val();
        if(_data.length>2){
        PostRec('https://nominatim.openstreetmap.org/search?q='+_data+'&format=json', _data, function(_err, ___data){        
          if(!_err){
            $('.store_form').addClass('opened');
            var addresses_drop = (___data ? get_all_addresses_popup(___data) : []);
            $('.addresses_drop').html('');
            if(addresses_drop.length>0){
              for(var _a=0; _a<addresses_drop.length; _a++){
                  $('.addresses_drop').addClass('opened').append("<li class='l_drop_li_cs' data-id='"+addresses_drop[_a]['id']+"'  "+
                                                "data-name='"+addresses_drop[_a]['title'].trim()+"' " +
                                                "data-address='"+addresses_drop[_a]['title'].trim()+"' " +
                                                "data-lat='"+addresses_drop[_a]['lat']+"' data-lng='"+addresses_drop[_a]['lon']+"'>"+addresses_drop[_a]['title']+"</li>");
              }
            } else{
                $('.store_form').addClass('opened');
            	$('.addresses_drop').addClass('opened').append("<li>No address found.</li>"); 
            }

          } else {
            $('.store_form').addClass('opened');
            $('.addresses_drop').addClass('opened').append("<li>No address found.</li>"); 
          }
        });
      } 
     });
  
  
  
  
     $('body').on('click', '.store_form.opened .form_block button.close_search', function(e){
          e.preventDefault();
          $('.store_form').removeClass('opened');
          $('.addresses_drop').removeClass('opened').html('');
        return false;
      });

     $('body').on('click', '.l_drop_li_cs', function(e) {
     	$('.store_form').removeClass('opened');
      	$('.addresses_drop').removeClass('opened').html('');
      	$('#praddress_incollection').val($(this).data('address'));
       // searchLocations_inpopup();
        searchLocationsNear_popup(parseFloat($(this).data('lat')),parseFloat($(this).data('lng')));
	});
  
  
  
  
  
  
  
  
  
  $(document).keyup(function(e) {
      if($('.popup_container').hasClass('opened')){
         if (e.key === "Escape") { 
           $('.popup_close').trigger('click');
        }
      }
    });
  
  
  if($('.flickity-page-dots').length){
    $('.flickity-page-dots').find('.dot').each(function(i){
    	$(this).attr('aria-label', 'Slide '+i);
    });
  }
  
  
  
  
      if(window.innerWidth < 420){
          if($('.watchreg_block .form_block').length){
             $('.watchreg_block .form_block').each(function(){
               if($(this).find('input').val()!='' || $(this).find('input').attr('placeholder')!==undefined){
                $(this).addClass('active');
               }
             });

             $('.watchreg_block .form_block input').change(function() {
               if($(this).val()!=''){
                $(this).parents('.form_block').addClass('active');
               }
             });
          }
      }
  
  
  
      $('.search_form').find('button').click(function(e){
        e.preventDefault();
        var searchval = $(this).parents('.search_form').find('#searchfield').val();
        console.log(searchval);
        if(searchval.charAt(0)!='"'){
          searchval = '"'+searchval;
        }
        
        if(searchval.slice(-1)!='"'){
          searchval = searchval+'"';
        }
        
        $(this).parents('.search_form').find('#searchfield').val(searchval);
        $('.search_form').submit();
        
      });
  
      if(window.location.hash && window.location.hash == '#view') {
        setTimeout(function(){
          if(!$('.template-product')[0]){
              if($('.collections_section.product_section').length){
                $("html, body").animate({ scrollTop: $('.collections_section.product_section').offset().top-50 }, 300);
              } else{
                $("html, body").animate({ scrollTop: $('.filters_all').offset().top-50 }, 300);
              }
          }
        }, 1300);
      }
  
  
      if($('.press_grid').length){
        setTimeout(function(){
          $('.press_grid').masonry({
              itemSelector: '.grid-item',
              columnWidth: '.grid-sizer',
              percentPosition: true
          });
         }, 1500);
      }
  
  	  $('.checkbox_button').on('click keypress', function(){
		if (!$(this).hasClass('checked')) {
			$(this).addClass('checked');
			$(this).parent().find('input').attr('state', 'checked');
		} else {
			$(this).removeClass('checked');
			$(this).parent().find('input').attr('state', 'not checked');
		}
	});
  
  
    $('.product_thumb.video').on('click keypress', function(e){
    	e.preventDefault();
        $('.prod_video .info_popup_inner').html('<iframe tabindex="0" src="https://www.youtube.com/embed/'+$(this).data('video')+'?enablejsapi=1&rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
		$('.product_media .prod_video.popup_blocks .info_popup_inner iframe').height($('.product_media .prod_video.popup_blocks .info_popup_inner').innerHeight());
		
		$(document).find('.product_media .prod_video .info_popup_inner').find('img').css("max-height", window.innerHeight-150);

		$('.prod_video .info_popup').addClass('opened').attr('aria-hidden', false);				
		$('body').addClass('y_hidden');			
		$('.loader_inner').css({'visibility':'hidden','opacity':'0'});
		$('.prod_video .popup_container').addClass('opened');
      	$(this).attr('aria-expanded', true);
    });

      $('.purchsed_from').on('change', function(){
        if($(this).find(":selected").val() == 2){
          $('.purchase_other').css('visibility', 'visible');
          $('#purchase_other').attr('data-validation', "length").
            attr('data-validation-length', "min1").
            attr('data-validation-error-msg', "Required field");
        }
        else{
          $('.purchase_other').css('visibility', 'hidden');
          $('#purchase_other').removeAttr('data-validation').
            removeAttr('data-validation-length').
            removeAttr('data-validation-error-msg');
        }
      });
  
  
  	  $('body').on('click', '.watchregistartionform', function(e){
		  //e.preventDefault(); 
     
         if($('.watchreg_form').length>0){
              $('#wr_thankyou').hide();

             var fileCheck = document.getElementById('watch_image').files[0];
             if(fileCheck === undefined){
               $('#watch_image').parents('label').addClass('has-error');
             }
             else{
               $('#watch_image').parents('label').removeClass('has-error');
             }
           
              $.validate({
                form: '.watchreg_form',
                scrollToTopOnError: false,
                onSuccess: function(){
                    if($('#wr_collection').val().trim()!=""  && ($('#purchsed_from').val()=="1" || ($('#purchsed_from').val()=="2" && $('#purchase_other').val().trim()!="")) && $('#wr_for').val().trim()!="" && $('#wr_model').val().trim().length>0 && $('#wr_serial').val().trim().length>0 && $('#wr_case').val().trim().length>0 && $('#wr_fname').val().trim().length>0  && $('#wr_lname').val().trim().length>0 && $('#wr_address').val().trim().length>0 && $('#wr_city').val().trim().length>0 && $('#wr_zip').val().trim().length>0 && $('#wr_phone').val().trim().length>0 && $('#wr_email').val().trim().match(/[\d\w\-\_\.]+@[\d\w\-\_\.]+\.[\w]{2,4}/i) && Validate_file('watch_image')){
                     $('.watchregistartionform').hide();
                     $('.schedulrequestform_loading').show();

                     var formData = new FormData();
                     var file = document.getElementById('watch_image').files[0];
                     formData.append('images', file);

                     formData.append('form',"watchregistration");
                     formData.append('collection',$('#wr_collection').val().trim());
                     formData.append('model',$('#wr_model').val().trim());
                     formData.append('serial',$('#wr_serial').val().trim());
                     formData.append('case',$('#wr_case').val().trim());
                     formData.append('gender',$('#wr_gender').val().trim());
                     formData.append('fname',$('#wr_fname').val().trim());
                     formData.append('lname',$('#wr_lname').val().trim());
                     formData.append('email',$('#wr_email').val().trim());
                     formData.append('address1',$('#wr_address').val().trim());
                     formData.append('address2',$('#wr_address2').val().trim());
                     formData.append('city',$('#wr_city').val().trim());
                     formData.append('zip',$('#wr_zip').val().trim());
                     formData.append('phone',$('#wr_phone').val().trim());
                     formData.append('birth',($('#wr_year').val()=="" ? "" : $('#wr_year').val()+".")+($('#wr_month').val()=="" ? "01" : $('#wr_month').val())+"."+($('#wr_day').val()=="" ? "01" : $('#wr_day').val()));
                     formData.append('education',$('#wr_education').val().trim());
                     formData.append('income',$('#wr_income').val().trim());
                     formData.append('other',$('#wr_other').val().trim());
                     formData.append('for',$('#wr_for').val().trim());
                     formData.append('retailer', ($('#purchsed_from').val()=="1" ? 'Seiko USA' : $('#purchase_other').val().trim()));
                     formData.append('subscribe',($("#wr_subscribe").prop('checked') ? 'Yes' : 'No'));

                     var xhr = new XMLHttpRequest();
                     xhr.open('post', 'https://seiko-luxe.herokuapp.com/postrequest', true);

                     xhr.upload.onprogress = function(e) {
                       if (e.lengthComputable) {
                       }
                     };
                     xhr.onerror = function(e) {
                     };
                     xhr.onload = function(date) {		
                       $('.watchreg_form')[0].reset();
                       $(".selectpicker").val('default');
                       $(".selectpicker").selectpicker("refresh");
                       $('.watchregistartionform').show();
                       $('.schedulrequestform_loading').hide();
                       $('#wr_thankyou').show();
                     };
                     xhr.send(formData);
                   }
                   return false;
                }
            });
         }
      });


      $("body").on('change', '#watch_image', function(event) {
          if(Validate_file('watch_image')){
               $('.imageuploaderbtn').html('ATTACHED');
          } else {
               $('.imageuploaderbtn').html('UPLOAD RECEIPT IMAGE*'); 
          }
      });


      $("#trigger_file_upload").keyup(function (e) {
        if (e.keyCode === 13) {
           $("#watch_image").click(); 
        }
      });  
  
  	  if($('#wr_year')[0]){
        var _yn=new Date();
        var _ynn=_yn.getFullYear();
        $('#wr_year').append('<option value="" selected>Year</option>');
        for(var _u=0; _u<120;_u++){
            $('#wr_year').append('<option value="'+(_ynn-_u)+'" >'+(_ynn-_u)+'</option>');
        }
      }
  
      $('body').on('click', '.pholder', function(){
          $(this).parent().find('input').trigger('focus');
      });

  
  	  setPholder();
  
      if(device.mobile() && $('#swipe_block').length){
          document.getElementById('swipe_block').addEventListener('touchstart', handleTouchStart, false);        
          document.getElementById('swipe_block').addEventListener('touchmove', handleTouchMove, false);
      }
  
      if($('.search_page_content')[0] && window.location.href.indexOf('loremipsum')==-1){
            loadAllProducts();
      } else if(window.location.href.indexOf('loremipsum')!=-1){
          StartFilter(); 
      }
  	
  	  document_width=$(document).width(); document_height=$(document).height();
  
  		
      if(document_width<768){
        
            if($('.shopify-section.catalog_section').length && !$('.luxe_video_block').length && !$('.story_gallery').length){
              $('.catalog_section .list_block:last-child').css('background-color', '#f3f3f3');
            }
        
            if(window.innerWidth > 420){
                  $('.product_description').find('.more_text').css("max-height", 200);
                  show_more_height = 200;
                }
            else{
              $('.product_description').find('.more_text').css("max-height", 165);
              show_more_height = 165;
            }
            $('.product_media').css('margin-top', 'inherit');
            $('.product_zoom_block').css('height', 'inherit');
            $('.product_thumbs_container').css('height', 'inherit');	
            $('.product_data').css("height", "inherit");
        
        
        	if($('.more_text .inner_text').innerHeight() > $('.more_text').innerHeight()){
                $('.show_more').fadeIn();
                $('.more_text').addClass('longtext');
            }
            else{
                $('.show_more').fadeOut();
                $('.more_text').removeClass('longtext');
            }
      }
  
  
      $('.collections_section.product_section .view_all').on('click', function(e){
        	e.preventDefault();
        	
        	if($(this).hasClass('show_all')){
              	$('.collections_section.product_section').find('.product_block.more_prods').removeClass('p_show').addClass('p_hide');
        		$(this).text('VIEW MORE').removeClass('show_all').attr('aria-expanded', false);
            }
            else{
				$('.collections_section.product_section').find('.product_block').removeClass('p_hide').addClass('p_show');
              	$(this).text('VIEW LESS').addClass('show_all').attr('aria-expanded', true);
            }
      });
  
  		/*if($('.support_tabs').length && window.innerWidth > 768){
          $(window).scroll(function(){          
            var scrollOffset = $(window).scrollTop();
            var loadOffset   = $('.support_container').offset().top-$('header').height();


            if($('.support_tab_block.active').height()>$('.support_tabs').innerHeight()){
              var absoluteFixed = $('.support_block').innerHeight() - $('.support_tabs').innerHeight();      

              if(scrollOffset>=absoluteFixed){
                $('.support_tabs').css({'position': 'absolute', 'top': absoluteFixed+40});
              }
              else{
                $('.support_tabs').removeAttr('style');
              }


              if(scrollOffset>=loadOffset){
                $('.support_tabs').addClass('fixed');
              }
              else{
                $('.support_tabs').removeClass('fixed');
              }
            }
            else{
              $('.support_tabs').removeClass('fixed').removeAttr('style');
            }
          });
        }*/
  
        
  
  		if($('.support_tab_block .manuals_form')[0]){
               LoadManuals();
        }
  
        if($('.support_tab_block .manuals_form').length > 0){
              $.validate({
                  form: '.manuals_form',
                  "onSuccess": function(e){
                      SearchManuals($('#manual_search_product').val());
                      return false;
                  }
              });
          }
  
  		$('.faq_col .question').on('click keypress', function(){
            if($(this).parent().hasClass('active')){
                $(this).parent().removeClass('active');
                $(this).attr('aria-expanded', false);
                $(this).find('.icon-close').attr('aria-label', 'Open the answer for '+$(this).find('.icon-close').data('title'));
                $(this).next('.answer').animate({ height: 0 }, 200).attr('aria-hidden', true).attr('state', 'collapsed');
            	$(this).parent().find('a').attr('tabindex', '-1');
            }
            else{
                $('.faq_col').removeClass('active');
                $(this).parent().addClass('active');
                $('.question').attr('aria-expanded', false);
                $('.question').find('.icon-close').attr('aria-label', 'Open the answer for '+$(this).find('.icon-close').data('title'));
                $(this).find('.icon-close').attr('aria-label', 'Close the answer '+$(this).find('.icon-close').data('title'));
                $(this).attr('aria-expanded', true);
                $('.answer').animate({ height: 0 }, 200).attr('aria-hidden', true).attr('state', 'collapsed');
                $(this).next('.answer').animate({ height: $(this).next('.answer').find('span').height()+20 }, 200).attr('aria-hidden', false).attr('state', 'expanded');
            	$(this).parent().find('a').attr('tabindex', '0');
            }
        });

        if($('.page-page_support').length){
          $('.page-page_support').find('.content').css('min-height', $('.support_tabs').innerHeight()+50);

          if(window.innerWidth < 920){
              window.onhashchange = function() {
                  window.location.reload();
              }
          }
        }
  
  
  		$(window).on('hashchange', function() {
            hashchangeSupport();
        });

        if(window.location.hash && $('.support_tab').length) {
            hashchangeSupport();
        }
  
  
  		$(document).on('click keypress', '.support_tab', function(){
            if($(this).attr('data-tab') == 'manuals'){ 
                  location.href = "https://www.seikowatches.com/us-en/customerservice/instruction";
            }
           if(!$(this).hasClass('linkto')){
              if(window.innerWidth <= 640){
                if($(this).parents('.support_tabs').hasClass('opened')){
                  $('.mobile_support').animate({height: 0, opacity: 0, overflow: 'hidden'}, animateTime);
                  $('.support_tab').first().attr('data-tab', $(this).attr('data-tab')).html($(this).html());
                  $('.support_tabs').removeClass('opened');
                }
                else{
                  autoHeightOpacityAnimate($('.mobile_support'), animateTime);
                  $('.support_tab').first().attr('data-tab', 'contact').html('CUSTOMER SERVICE');
                  $('.support_tabs').addClass('opened');
                }
              }
              else{
                  supportTabs($(this));
              }
             
             $(this).find('a').attr('tabindex', '0');
             
             $('.support_tab_block.faq a').attr('tabindex', '-1');
  			 $('.support_tab_block a[target="_blank"]').attr('aria-label', 'opens in new window');
             
             $('.support_tab_block.active a:visible, .support_tab_block.active div[tabindex="0"], .support_tab_block.active button[tabindex="0"], .support_tab_block.active input[tabindex="0"]').last().keydown(function(e) {
                var code = e.keyCode || e.which;
                if (!e.shiftKey && code == '9') {

                  if($('.support_tabs .support_tab.active').attr('data-tab') == "contact"){
                      $('.support_tabs .mobile_support .support_tab').first().focus();
                  }
                  else{
                      $('.support_tabs .support_tab.active').next().focus();
                  }
                  return false;
                }
              });
      	
           }
		});
  
  		$('.support_tabs .support_tab').keydown(function(e) {

         if($(this).attr('data-tab') == 'manuals'){ 
                  location.href = "https://www.seikowatches.com/us-en/customerservice/instruction";
          }
          var code = e.keyCode || e.which;
          if(!e.shiftKey && code == '9') {
            if ($(this).hasClass('active')){
                if($('.support_tab_block.active div[tabindex="0"]').length){
                  $('.support_tab_block.active div[tabindex="0"]').first().focus();
                }
                else if($('.support_tab_block.active input[tabindex="0"]').length){
                  $('.support_tab_block.active input[tabindex="0"]').first().focus();
                }
                else if($('.support_tab_block.active a').length){
                  $('.support_tab_block.active a').first().focus();
                }
                else{
                    return true;
                }
                return false;
            }
            else{
              if(!$(this).attr('data-tab')){
                  $('.footer a').first().focus();
                  return false;
              }
            }
          }
        });

  		$('.support_tab_block.active a:visible, .support_tab_block.active div[tabindex="0"], .support_tab_block.active button[tabindex="0"], .support_tab_block.active input[tabindex="0"]').last().keydown(function(e) {
          var code = e.keyCode || e.which;
          if (!e.shiftKey && code == '9') {
            
            if($('.support_tabs .support_tab.active').attr('data-tab') == "contact"){
                $('.support_tabs .mobile_support .support_tab').first().focus();
            }
            else{
            	$('.support_tabs .support_tab.active').next().focus();
            }
            return false;
          }
        });


  		$(document).on('click keypress', '.support_tabs.opened .support_tab', function(){
        	supportTabs($(this));
        });
  
  
  			
  
		$(window).scroll(function(){
          
          if(!$('body').hasClass('page-index')){
            scrollCb();
          }
          
          if($('.search_page_content').length){
            if(!_loadingcollectionproducts){
              var scrollOffset = $(window).scrollTop();
              var loadOffset   = $('.footer').offset().top-900;

              if(scrollOffset > loadOffset){
                  NexstFilteredList();
              }
            }
          }
          
          if($('.template-collection')[0]){
            if(!_loadingcollectionproducts){
              var scrollOffset = $(window).scrollTop();
              var loadOffset   = $('.footer').offset().top-900;

              if(scrollOffset > loadOffset){
                  NexstFilteredList();
              }
            }
		  }	
          
           if($('.press_grid')[0] && _ajaxloadpresspage>0){
              var scrollOffset = $(window).scrollTop();
              var loadOffset   = $('.footer').offset().top-1300;

              if(scrollOffset > loadOffset && _canayaxload){
         		 loadPressNextPage();
              }
           }
		});
  

	$('.mobile_filters').click(function(){
      if($('.collection_filters').height() === 0){
        autoHeightAnimate($('.collection_filters'), animateTime);
        $('.filters_all').addClass('open');
      } else {
        $('.collection_filters').stop().animate({ height: '0' }, animateTime);
        $('.filters_all').removeClass('open');
      }
	});

  	
  	if($('#video_10').length){
		var myPlayer = videojs("video_10", {"controls": true, "autoplay": true, "muted": true, "preload": "auto"}, function(){
			var player = this;
			player.on('ended', function() {	
              this.play();
			}).on('seeking', function (e) {												
			}).on('play', function (e) {						
			}).on('pause', function(e) {												
			});
		});
      	$('#video_10').find('.vjs-tech').attr('tabindex', 0);
      
      
       $("#video_10").keyup(function (e) {
          if (e.keyCode === 13) {
            var video = $('#video_10 > video');
            var videoElement = video.get(0);
            if (!videoElement.paused) {myPlayer.pause();}
            else{myPlayer.play();}
            
          }
       }); 
	}
  
  	if($('.vjs-tech').length){
      if(window.innerWidth<480){
        $('.vjs-tech').attr('playsinline', 'true'); 
      }
      else{
        $('.vjs-tech').removeAttr('playsinline');
      }
    }
  
  	if(window.innerWidth > 640){
      if($('#video_1').length){
          var myPlayer = videojs("video_1", {"controls": true, "loop": true, "autoplay": true, "muted": true, "preload": "auto"}, function(){
              var player = this;
              player.on('ended', function() {					
              }).on('seeking', function (e) {												
              }).on('play', function (e) {						
              }).on('pause', function(e) {												
              });
          });	
      }
    }
    else{
		if($('#video_1_m').length){
          var myPlayer = videojs("video_1_m", {"controls": true, "loop": true, "autoplay": true, "muted": true, "preload": "auto"}, function(){
              var player = this;
              player.on('ended', function() {					
              }).on('seeking', function (e) {												
              }).on('play', function (e) {						
              }).on('pause', function(e) {												
              });
          });	
      }
    }
  
  	

    $(document).on('click touchstart keypress', '.video_tutorial, .play-button', function(e){
      e.preventDefault();
      
	  
      if($('.popup_blocks .info_popup_inner').html() == ''){ 
      	$('.popup_blocks .info_popup_inner').html('<iframe id="vimeo-player" allow="autoplay" src="https://player.vimeo.com/video/'+$('.video_tutorial').attr('data-video')+($('.video_tutorial').attr('data-video').indexOf('?')==-1 ?'?':'&')+'autoplay=1&muted=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
        vimeoiframe = $('#vimeo-player')[0];
		vimeoplayer = new Vimeo.Player(vimeoiframe);
      }
      else{
      	vimeoplayer.play();
      }
      
      if(window.innerWidth > 640){
        
        if($('#video_1').length){
          myPlayer.pause();
        }
      }
      else{
      	if($('#video_1_m').length){
          myPlayer.pause();
        }        
      }
      
      
      

      $(this).attr('aria-expanded', true);
      $('.popup_blocks .info_popup_inner iframe').height($('.popup_blocks .info_popup_inner').innerHeight());
      $('.popup_blocks .info_popup').addClass('opened').attr('aria-hidden', false);				
      $('body').addClass('y_hidden');			
      $('.loader_inner').css({'visibility':'hidden','opacity':'0'});
      $('.popup_blocks .popup_container').addClass('opened');  
      $('.luxe_video_block, .category_block_inner').addClass('blur');
      $('.video_copy, .cat_desc_block span').addClass('blur_text');
      
      $('.focus_catcher').keydown(function(e) {
            var code = e.keyCode || e.which;
            if (!e.shiftKey && code == '9') {
              $('.popup_close').focus();
              return false;
            }
        });
      
      setTimeout(function(){
      	$('.popup_close').focus();
      }, 100);
      
      $('#shopify-section-header, .footer, #maincontent > div[class!="coll_video"]').attr({'aria-hidden': true, 'tabindex': "-1"});
  
    });
  
    $('.collection_video').on('click', function(e){
		$('#shopify-section-header, .footer, #maincontent > div[class!="coll_video"]').attr({'aria-hidden': false, 'tabindex': 0});
  		$('.video_tutorial, .play-button').attr('aria-expanded', false);
       	$('.popup_blocks .info_popup').attr('aria-hidden', true);	
    });
  	

    $('.popup_close, .popup_close_span').click(function(e){
      e.preventDefault();

      
      if(window.innerWidth > 640){
        if($('#video_1').length){
          myPlayer.play();
        }
      }
      else{
      	if($('#video_1_m').length){
          myPlayer.play();
        }
      }
      
       if($('.popup_close').length){
       	$('.prod_video .info_popup_inner').empty();
       }
      
      
      $(this).parents('.popup_container').removeClass('opened');	
      $(this).parents('.info_popup').removeClass('opened');

      $('body').removeClass('y_hidden');
      if($('.popup_blocks .info_popup_inner iframe').length){
        vimeoplayer.pause();
      }
      $('.luxe_video_block, .category_block_inner').removeClass('blur');
      $('.video_copy, .cat_desc_block span').removeClass('blur_text');
    });

    /*$('.info_popup, .info_popup_video').click(function(e) {
      if($(e.target).is('.cell_middle')){
        $('.popup_close').trigger('click');
      }
    });*/

	//$('.video-js .vjs-tech').css('margin-top', -($('.video_viewport').innerHeight()/2-60)+'px');
	//$('.vjs-loading-spinner').css('top', ($('.video_viewport').innerHeight()/2)+'px');
	//$('.vjs-control-bar').css('top', ($('.video_viewport').innerHeight()-70)+'px');

	if ($('.selectpicker').length > 0) {
        $('.selectpicker').selectpicker();
      	$(".bootstrap-select").find('.dropdown-menu').attr('state', 'collapsed');
        setTimeout(function(){
          $(".bootstrap-select").find('.dropdown-menu a').attr('tabindex', '-1');
        },100);
		$(".bootstrap-select").click(function () {
			
			if($(this).find('.dropdown-menu').height() === 0){
				$('.dropdown-menu').stop().animate({ height: '0' }, animateTime);
              
              	$(".bootstrap-select").find('.dropdown-menu').attr('state', 'collapsed').attr('aria-expanded', false);
              	$(this).find('.dropdown-menu').attr('state', 'expanded').attr('aria-expanded', true);
              
              	$(".bootstrap-select").find('.btn-default').attr('aria-expanded', false);
              	$(this).find('.btn-default').attr('aria-expanded', true);
              
              	$(".bootstrap-select").find('.dropdown-menu a').attr('tabindex', '-1');
              	$(this).find('.dropdown-menu a').attr('tabindex', 0);
              
                if(window.innerWidth <= 640){
                  //autoHeightAnimateBoot($(this).find('.dropdown-menu'), animateTime);
                  
                  $('.filters_all').addClass('open');
                  var li_count = $(this).find('.dropdown-menu li').length;
                  var li_height = $(this).find('.dropdown-menu li').height();
                  
                  var fb_count = $('.collection_filters').find('.btn-default').length;
                  var fb_height = $('.collection_filters').find('.btn-default').height();
                  
                  $(this).find('.dropdown-menu').stop().animate({ height: li_count*li_height-25, 'max-height': li_count*li_height + 30 }, animateTime);
                  
                  $('.collection_filters').stop().animate({ height: fb_count*fb_height + li_count*li_height + 120 }, animateTime);
                 }
                else{
                  autoHeightAnimate($(this).find('.dropdown-menu'), animateTime);
                }
			} else {
                $(this).find('.dropdown-menu').stop().animate({ height: '0' }, animateTime);
              	$(this).find('.dropdown-menu').attr('state', 'collapsed').attr('aria-expanded', false);
                $(this).find('.btn-default').attr('aria-expanded', false);
              	$(this).find('.dropdown-menu a').attr('tabindex', '-1');
              	if(window.innerWidth <= 640){
                  var fb_count = $('.collection_filters').find('.btn-default').length;
                  var fb_height = $('.collection_filters').find('.btn-default').height();
                  $('.collection_filters').stop().animate({ height: fb_count*fb_height + 90}, animateTime);
                }
			}
          
			
			if($(this).hasClass("show")){
				$(this).removeClass("show");						
			}
			else{
				$(".bootstrap-select").removeClass("show");
				$(this).toggleClass("show");
			}
	    });
      
      		
      
      
      var filter_all_count = 0;
      $(".filters_all .selectpicker").on("changed.bs.select", function(e, clickedIndex, newValue, oldValue) {
        var selected_count = $(this).parents('.bootstrap-select').find('.dropdown-menu li.selected').length;
        if(selected_count>0){
          $(this).parents('.bootstrap-select').find('.filter-option').append('<span class="sel_count"> (' + selected_count + ')</span>');
        }
        
        if($('.collection_filters .bootstrap-select').find('.dropdown-menu li.selected').length > 0){
        	$('.mobile_filters').find('.sel_count').html(' ('+$('.collection_filters  .bootstrap-select').find('.dropdown-menu li.selected').length+')');
        }
        else{
          	$('.mobile_filters').find('.sel_count').html('');
        }
      });
      
      $(".selectpicker").on("loaded.bs.select", function(e) {
      	if($('.watch_filters').length){
          $('.watch_filters').find('.dropdown-menu a').attr('tabindex', '-1');
        }  
      });
      
      $(document).on('keypress', 'div.dropdown-menu.open li', function (e) {
      	$(this).find('a').trigger('click');
      });
      
	}


	if($('.bootstrap-select').length){
		$('body').click(function(e){
          if(window.innerWidth > 640){
			if (!$(e.target).parents().hasClass('bootstrap-select')) {
				$(".bootstrap-select").removeClass("show");
              	$(this).find('.dropdown-menu').attr('state', 'collapsed').attr('aria-expanded', false);
              	$(this).find('.dropdown-menu a').attr('tabindex', '-1');
                $(this).find('.btn-default').attr('aria-expanded', false);
                $('.dropdown-menu').stop().animate({ height: '0' }, animateTime);
			}
          }
		});
	}
  
  	

  
  
    setTimeout(function(){
        if($('.collection_filters .bootstrap-select').find('.dropdown-menu li.selected').length > 0){
          $('.mobile_filters').find('.sel_count').html(' ('+$('.collection_filters .bootstrap-select').find('.dropdown-menu li.selected').length+')');
        }
    }, 1000);
  	
  
  
    $('body').on('change', '.selectpicker', function(evt) {
       _productslistshow=1;
       StartFilter();
    });
  
	$('body').on('click', '#resetfilterbtn_link', function(evt) {
		evt.preventDefault();
		/*$("#filter_color").val("0").change();
        $("#filter_material").val("0").change();
        $("#filter_movement").val("0").change();
        $("#filter_size").val("0").change();*/
        if(window.innerWidth > 640){
          $('.dropdown-menu').stop().animate({ height: '0' }, animateTime);
          $(".bootstrap-select").removeClass("show");
        }
      	$('.selectpicker').val('default').selectpicker('deselectAll');
        $('.selectpicker').selectpicker('refresh');
        productslistshow=1;
 		StartFilter();
		return false;
	});	
  
  
  
  
	$(window).on('scroll', function () {
		if($('.category_block').length && $('.list_block').length){
			removePadding();
		}

		if($('.scaled').length){
			removeScale();
		}
	});
  
	
	if($('.parallax_bg').length > 0) {		
		$(window).scroll(function(e){
			if(window.innerWidth < 768){
				parallax('parallax_bg', 50, 0.4, 'top');
			}
			else{
				parallax('parallax_bg', 60, 0.4, 'top');
			}
		});
	}
	
	if($('.parallax_blocks').length > 0) {
        /*if(window.innerWidth > 640){
          $('.parallax_blocks').each(function(){
              var _this_pb = $(this);			
              $(window).scroll(function(e){	
                  parallax_blocks(_this_pb, 0, 0.1, 'top');	
              });
          });
        }
        else{*/
          $(window).on('scroll', function(){
              paralaxCollectionBanners();
          });
        //}
    }
	

	$('.show_more a').click(function(){
		if(!$(this).parent().hasClass('opened')){
            if(window.innerWidth > 768){
              $(this).parents('.product_desc_cont').css('margin-bottom', '40px');
            }
          	$(this).parent().addClass("opened");
			$('.product_description').find('.more_text').addClass('opened').css('max-height', ($('.product_description').find('.more_text .inner_text').innerHeight() + 50));
        }
		else{
            if(window.innerWidth > 768){
              $(this).parents('.product_desc_cont').css('margin-bottom', '0');
            }
          	$(this).parent().removeClass("opened");
			$('.product_description').find('.more_text').removeClass('opened').css('max-height', show_more_height);
		}
          $('.show_more a').show();
          $(this).hide();
        
	});

	if ($('.product_zoom_block').length > 0) {
		if(!device.mobile()){

		  	$('.tile')
		    .on('mouseover', function(){
				$(this).children('.zoom_block').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
		    })
		    .on('mouseout', function(){
				$(this).children('.zoom_block').css({'transform': 'scale(1)'});
		    })
		    .on('mousemove', function(e){
				$(this).children('.zoom_block').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
		    })
            .on('keyup', function(e){
            	var key = e.which;
              
                if(key == 13) {
                  $(this).children('.zoom_block').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
                }
                if(e.key === "Escape") {
                  $(this).children('.zoom_block').css({'transform': 'scale(1)'});
                }
                if(e.key === "ArrowUp"){
                  $(this).children('.zoom_block').css({'transform-origin': '50% 0'});
                }
              	if(e.key === "ArrowDown"){
                  $(this).children('.zoom_block').css({'transform-origin': '50% 100%'});
                }
              	if(e.key === "ArrowLeft"){
                  $(this).children('.zoom_block').css({'transform-origin': '0 50%'});
                }
              	if(e.key === "ArrowRight"){
                  $(this).children('.zoom_block').css({'transform-origin': '100% 50%'});
                }
            });;
		}
	}
  
    

	if($('.home_preloadimage').length){
		loadAllBGImages($('.home_preloadimage'), function(){
			setTimeout(function(){
				$('.loader_start').css({'visibility':'hidden','opacity':'0'});
				$('.home_fold_block').addClass('show');
			}, 100);			
		});
		if($('.catalog_preloadimage').length){
			loadAllBGImages($('.catalog_preloadimage'), function(){});
		}
	} 
	else{
		if($('.catalog_preloadimage').length){
			loadAllBGImages($('.catalog_preloadimage'), function(){
				setTimeout(function(){
					$('.loader_start').css({'visibility':'hidden','opacity':'0'});
				}, 100);
			});
		}
      	else{
          setTimeout(function(){
              $('.loader_start').css({'visibility':'hidden','opacity':'0'});
          }, 100);
      }
	}

	
	/**/


	function closeAllMenues(evt) {
		if ($(".search_open_button").hasClass("opened")) {
			$(".search_open_button").removeClass("opened");
			$(".search_form").removeClass("opened");
            $(".search_form").find('input').attr('tabindex', '-1');
          	$(".search_form").find('button').attr('tabindex', '-1');
			$(".search_form input").val("");
		}
	};

	$('body').click(closeAllMenues);
	
	$(".search_open_button").on("click" , function(evt){
		closeAllMenues(evt);
		evt.stopPropagation();
		$(this).addClass("opened");
		$(".search_form").addClass("opened");
        $('.search_form').attr('aria-expanded', true);
      	$(".search_form").find('input').attr('tabindex', 0);
      	$(".search_form").find('button').attr('tabindex', 0);
	});
	$(".search_form").on("click" , function(evt){
		evt.stopPropagation();
	});
  
  
  
  	$('.product_thumb').on('click keypress', function(){
    	if($(this).data('image')){
    		$('.product_thumb').removeClass('active').attr('aria-expanded', false);
    		$(this).addClass('active').attr('aria-expanded', true);
    		if($('.product_thumb.active').is(':first-child')){
    			$('.zoom_shadow').show();
    		}
    		else{
    			$('.zoom_shadow').hide();
    		}
          
          	$('.photo_zoom').html('<img src="'+$('.photo_zoom').attr('data-spin')+'" alt="" title="" class="spinner" />');
          	$(document).find('.photo_zoom').css('background-image', 'none');	
          
          	var img = new Image();
            img.src = $(this).data('image');

            img.onload = function() {
              $('.photo_zoom').html('');
              $(document).find('.photo_zoom').css('background-image', 'url('+img.src+')');			
            }
    	}
    });
  
    if($('.photo_zoom').length){
      $('.photo_zoom').html('<img src="'+$('.photo_zoom').attr('data-spin')+'" alt="Loading" title="" class="spinner" />');
      
      
      var img = new Image();
      img.src = $('.photo_zoom').attr("data-src");

      img.onload = function() {
        $('.photo_zoom').addClass('loaded');
        $('.photo_zoom').css('background-image', 'url('+img.src+')');
        $('.photo_zoom').html('');
        $('.photo_zoom').next('.zoom_shadow').css('background-size', 'contain');				
      }
    }
  
  	/*$('.product_thumb.video').click(function(e){
    	e.preventDefault();
    	
    	if($(this).data('video')){
    		$('.info_popup_inner').html('<iframe src="https://www.youtube.com/embed/'+$(this).data('video')+'?enablejsapi=1&rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
    	}
    	else{
			$('.info_popup_inner').html('<img src="'+$(this).data('image')+'" alt="" title="" />');
		}

		$('.product_media .popup_blocks .info_popup_inner iframe').height($('.product_media .popup_blocks .info_popup_inner').innerHeight());
		
		$(document).find('.product_media .info_popup_inner').find('img').css("max-height", window.innerHeight-150);

		$('.info_popup').addClass('opened');				
		$('body').addClass('y_hidden');			
		$('.loader_inner').css({'visibility':'hidden','opacity':'0'});
		$('.popup_container').addClass('opened');
    });*/


	$(window).resize(function() {
      
      
      	$('.faq_col.active').find('.answer').animate({ height: $('.faq_col.active').find('.answer').find('span').height()+20 }, 50);
      	


		if(window.innerWidth > 640){				
			$('.story_text').height($('.story_image').innerHeight());			
		}
        else{
          setTimeout(function(){
            $('.story_text').height($('.story_gallery .flickity-viewport').innerHeight() - $('.story_image').innerHeight() + 10);	
          }, 10);
        }
        
      
        /*if((window.innerWidth - $('.main_menu_inner').width())<200){
          $('.header .close_menu_button').css('width', (window.innerWidth - $('.main_menu_inner').width()));
        }*/	
      	
		
		var fold_height_content = window.innerHeight-$('.header_top').height();
      	$('.error_container').height(fold_height_content);
      	$('.search_page_content').css('min-height', fold_height_content-$('footer').height()-20);
      
      	$('.support_container').css('min-height', fold_height_content-$('footer').height()-20);
		
		var fold_height = window.innerHeight-$('.header_top').height();	
      
      
      
      	if($('.findstore').length){
			
			
			if(window.innerWidth > 640){
				$('.l_map_wrap_right').css('height', fold_height_content);
				$('.l_map_wrap_left_scrl').css('height', $('.l_map_wrap_right').height()-$('.l_map_wrap_left .store_form').innerHeight() - 60);
			}
			else{
                $('.filter_selection').html('Filter');
				$('.mobile_map_helper').css('height', '220px');
                $('.l_map_wrap_left_scrl').css('height', fold_height - $('.mobile_map_helper').height() - $('.store_form').height() + 40);
			}
			
			
			if(window.innerWidth > 640){
				$('#mapid').css({'height': $('.l_map_wrap_right').height(), 'width': window.innerWidth-$('.l_map_wrap_left').innerWidth()});
			}
			else{
              	$('#mapid_mobile').css({'height': $('.mobile_map_helper').height(), 'width': window.innerWidth});
			}
          
          	
		}
      
      
 		$('.filter_selection').on('click', function(){
            if($('.collections_filter_s').height() == 0){
              $('.collections_filter_s').addClass('active').stop().animate({"height": 170, "opacity":"1"}, 400);
              $(this).addClass('active');
            }	
            else{
              $('.collections_filter_s').removeClass('active').stop().animate({"height": 0, "opacity":"0"}, 400);
              $(this).removeClass('active');
            }
        });
      
        if($('.filter_selection').length){
          $('body').on('click touchstart', function (event) {
              if($('.filter_selection').hasClass('active')){
                if (!$(event.target).closest('.addresses_drop').length && !$(event.target).closest('.collections_filter_s').length && !$(event.target).closest('.filter_selection').length) {
                  $('.collections_filter_s').removeClass('active').stop().animate({"height": 0, "opacity":"0"}, 400);
                  $('.filter_selection').removeClass('active');
                }
              }
          });
        }
      
      

		if(window.innerWidth > 768){
			
            $('.product_description').find('.more_text').css("max-height", 200);
            show_more_height = 200;
			

            //$('.product_zoom_block').height($('.product_description').height()/2+380);
          
          	var produ_zoom_height = window.innerHeight-$('.header_top').height();
            if(produ_zoom_height>700){
              $('.product_zoom_block').height(produ_zoom_height);
            }
            else{
				$('.product_zoom_block').height(produ_zoom_height-30);
            }
            

			$('.product_thumb').height($('.product_thumb').width());
			$('.product_data').height((fold_height<$('.product_thumbs_block').height() ? $('.product_thumbs_block').height()+40 : fold_height));


          	var img_cont_padd = (fold_height-$('.photo_zoom').height())/3;
            if(img_cont_padd>0){
                $('.product_image_container').css('padding-top', (fold_height-$('.photo_zoom').height())/2);
            }
            else{
				$('.product_image_container').css('padding-top', 20);
            }
          	$('.product_thumbs_block').css('padding-top', (fold_height-$('.product_thumbs_block').height())/2);
          
          
            setTimeout(function(){
              $('.product_description').css('padding-top', (fold_height-$('.product_description').innerHeight())/2);
            }, 200);
			
			
			$('.product_thumbs_container').height($('.product_image_container').height());		
          
            $('.product_zoom_container').height($('.product_data').innerHeight());
            
		} 
        /*else{
          if(document_width!=$(document).width()){
              if(window.innerWidth > 420){
                $('.product_description').find('.more_text').css("max-height", 190);
                show_more_height = 190;
              }
              else{
                $('.product_description').find('.more_text').css("max-height", 170);
                show_more_height = 170;
              }
              $('.product_media').css('margin-top', 'inherit');
              $('.product_zoom_block').css('height', 'inherit');
              $('.product_thumbs_container').css('height', 'inherit');	
              $('.product_data').css("height", "inherit");
           }
		}*/

	
		if(window.innerWidth > 768){
          if($('.more_text .inner_text').innerHeight() > $('.more_text').innerHeight()){
              $('.show_more').fadeIn();
              $('.more_text').addClass('longtext');
          }
          else{
              $('.show_more').fadeOut();
              $('.more_text').removeClass('longtext');
          }
        }

		
		//if($('.home_fold_block').length){
			//if(!device.mobile()){
				//$('.home_fold_block, .home_fold_block .carousel-cell').height(window.innerHeight-$('.header_top').height());
			//}
		//}
		/*
		if($('.home_fold_block').length){
			if(device.mobile()){
				if(window.innerWidth < 768){
					$('.home_fold_block, .home_fold_block .carousel-cell').height(window.innerHeight-$('.header_top').height());
				}
			}
		}
		*/

		
		/*$(document).unbind('click').on('click touchstart', function (event) {
			if($('body').hasClass('openednav')){
			  if (!$(event.target).closest('.main_menu_inner').length && !$(event.target).closest('.menu_button').length) {
			  	closeNav($carousel);
			  }
			}
		});*/

		/*if(window.innerWidth>920){
			$('body.openednav .main_menu_inner').height($('.menu_product_block').innerHeight()+81);
			$('.menu_text_block').css('padding-top', ($('.menu_product_block').height()-$('.menu_text_block').height())/2);
		}
		else{
			$('body.openednav .main_menu_inner').height($('.menu_watches_block').innerHeight()+$('.menu_text_block').innerHeight()+90);
			$('.menu_text_block').css({'padding-top': '20px', 'padding-bottom': '20px'});
			$('.menu_watches_block').scrollLeft( (600-window.innerWidth)/2 );
		}*/
		
	
		if($('.story_gallery .flickity-page-dots').length){

			if(window.innerWidth>640){
				if($('.story_text').height()>$('.story_text_block').height()+50){
					var offset_story = 20;
				} else{
					var offset_story = 0;
				}

              	var story_off = ($('.story_text').height()-$('.story_text_block').height())/2;
				$('.story_gallery .flickity-page-dots').css({'left': $('.story_text_block').offset().left-10, 'top': (story_off+story_off/2+$('.story_text_block').height()-50)});
			}
			else{
				$('.story_gallery .flickity-page-dots').removeAttr('style');
			}
          	
		}

		if($('.parallax_bg').length){
			$('.parallax_bg').height($('.parallax_height').innerHeight());
		}
      
		
		/*if(window.innerWidth>640){
			if($('.parallax_blocks').length){
				$('.parallax_blocks').each(function(){
					$(this).height($(this).parents('.parallax_height').innerHeight());
				});			
			}
		}*/
		
		if($('.parallax').length){
			$('.parallax').each(function(){
				$(this).height($(this).parents('.parallax_height').innerHeight());
			});
		}


	}).trigger('resize');

	

	
	
	if($('.home_fold_block .carousel').length){
		var $carousel = $('.home_fold_block .carousel').flickity({
			bgLazyLoad: true,
			wrapAround: true,
            selectedAttraction: 0.02,
			friction: 0.3,
          	autoPlay: true
		});
	}

	if($('.story_gallery').length){
		_story_corusel = $('.story_gallery').flickity({
			pageDots: true,
			wrapAround: true,
			draggable: true,
          	pauseAutoPlayOnHover: false,
          	//autoPlay: 4000
		});
      
     	$('body').on('click', '.story_gallery .flickity-page-dots .dot', function (e) {
           var index = $(this).index();
           var story_off = ($('.story_gallery_cell').eq(index).find('.story_text').height()-$('.story_gallery_cell').eq(index).find('.story_text_block').height())/2;
           $('.story_gallery .flickity-page-dots').css({'top': (story_off+story_off/2+$('.story_gallery_cell').eq(index).find('.story_text_block').height()-50)});
        });
      
		if(window.innerWidth>640){
			if($('.story_gallery .flickity-page-dots').length){
				if($('.story_text').height()>$('.story_text_block').height()+50){
					var offset_story = 20;
				} else{
					var offset_story = 0;
				}
				var story_off = ($('.story_text').height()-$('.story_text_block').height())/2;
				$('.story_gallery .flickity-page-dots').css({'left': $('.story_text_block').offset().left-10, 'top': (story_off+story_off/2+$('.story_text_block').height()-50)});
			}
		}

      
      	$('.story_gallery .flickity-page-dots .dot').each(function(){
          $(this).attr({'aria-label': 'Slide '+($(this).index()+1), 'aria-controls': "Collection-carousel-items", 'role': 'button'});
        });


        $('.story_gallery .flickity-page-dots .dot').attr('tabindex', 0);
        _story_corusel.on('cellSelect', function() {
          $('.story_gallery_cell.is-selected').attr('aria-label', $('.story_gallery_cell.is-selected').attr('aria-label')+' current slide');
          $('.story_gallery .flickity-page-dots .dot').attr('aria-pressed', false);
          $('.story_gallery .flickity-page-dots .dot.is-selected').attr('aria-pressed', true);
        });

        $('.story_gallery .flickity-page-dots .dot').keydown(function(e) {
          var code = e.keyCode || e.which;
          if(code == 13) {
            var index = $(this).index();
            $('.story_gallery .flickity-page-dots .dot').removeClass('is_selected');
            $(this).addClass('is_selected');
            _story_corusel.flickity('select', index);
          }
        });



        $('.story_gallery .flickity-page-dots .dot').focusin(function(e) {
            var index = $(this).index();
            $('.story_gallery .flickity-page-dots .dot').removeClass('is_selected');
            $(this).addClass('is_selected');
            _story_corusel.flickity('select', index);
        });


        $('.story_gallery .story_text_block .standard_button:not(.learn_more)').focusin(function(e) {
          	e.stopPropagation();
          	e.preventDefault();
          	
            var index = $(this).parents('.story_gallery_cell').index();
          console.log(index);
          	_story_corusel.flickity('select', index);
          
          setTimeout(function(){
          	$('.story_gallery .flickity-viewport').css('position', 'static');
            setTimeout(function(){
              $('.story_gallery .flickity-viewport').css('position', 'relative');
            },10);
          },100);
          
          	return false;
        });
      

	}
  
  	
  	$('.menu_button.mobile_menu').on('click keypress', function(){
		openNav($carousel, $(this));		
	});
  	
  
    $(".menu_button_collections").hover(
      function(event) {
        if($('.main_menu_inner').height() === 0){
        	openNav($carousel, $(this));	
        }
      }
    );
  
  	$(".menu_button_collections").on('keyup', function(evt){
      if(evt.keyCode == 13){
      	openNav($carousel, $(this));
      }
      else if(evt.key == "Escape"){
      	if($('.main_menu_inner').height() !== 0){
        	openNav($carousel, $(this));	
        }
      }
    });
  
    
      $(document).on('mouseover', 'body', function(e) {
        if(window.innerWidth > 1024){
          if($('.main_menu_inner').height() !== 0){
            if (!$(event.target).closest('.main_menu_inner').length && !$(event.target).closest('.menu_button_collections').length && !$(event.target).closest('.menu_button.mobile_menu').length) {
                openNav($carousel, $(this));
            }
          }
        }
      });

  
  	$('.overlay').unbind('click').on('click touchstart', function (event) {
      	if (!$(event.target).closest('.main_menu_inner').length && !$(event.target).closest('.menu_button_collections').length && !$(event.target).closest('.menu_button.mobile_menu').length) {
          if(window.innerWidth > 1024){
         	 openNav($carousel, $('.menu_button_collections'));
          }
          else{
          	 openNav($carousel, $('.menu_button.mobile_menu'));
          }
        }
    });
  	
	
	/*$('.menu_button').on('click keypress', function(){
		openNav($carousel, $(this));		
	});
  
  	$('.overlay').unbind('click').on('click touchstart', function (event) {
      	if (!$(event.target).closest('.main_menu_inner').length && !$(event.target).closest('.menu_button').length) {
          openNav($carousel, $('.menu_button'));
        }
    });*/
	/*$('.close_menu_button').click(function(){
		closeNav($carousel);
	});*/
  
  
  
      /////////////////GEVORGS SCRIPTS STARTS///////////////////////////////////////////////////////////
      if($('.template-index')[0] || $('.shop_social.home')[0]){
            LoadShopSocialJSON(_manual_shop_social_json_url,0,function(_manual_socials) {
              if(_manual_socials.length>0){
                    __shop_social=_manual_socials;
                   ShopSocialCreate('home');
              } else {
                    LoadShopSocialJSON(_auto_shop_social_json_url,0,function(_auto_socials) {
                         __shop_social=_auto_socials;
                        ShopSocialCreate('home');
                    });
              }
          });

      }
  
  
       if($('.template-collection')[0]){
           CreateFilters();

           LoadShopSocialJSON(_manual_shop_social_json_url,_collection_id,function(_manual_socials) {
              if(_manual_socials.length>0){
                    __shop_social=_manual_socials;
                   ShopSocialCreate('catalog');
              } else {
                    LoadShopSocialJSON(_auto_shop_social_json_url,_collection_id,function(_auto_socials) {
                         __shop_social=_auto_socials;
                        ShopSocialCreate('catalog');
                    });
              }

          });
      	}
  
  		$('body').on('keypress', '.social_link', function (e) {
           var key = e.which;
           if(key == 13) {
                openSocialPopup($(this));
           }
        }); 
  
  		$('body').on('click','.social_link', function(e){
            e.preventDefault();
            openSocialPopup($(this));		
        });
  
  		$('body').on('click','.social_add_to_cart', function(e){
            e.preventDefault();
            $.post('/cart/add.js', {quantity: 1, id: $(this).attr('data-id')});
           // $(this).hide();
           $(this).html('ADDED').prop("disabled", true).css('pointer-events', 'none'); 
            var _count=$('#items_in_cart_count').html()!='' ? parseInt($('#items_in_cart_count').html())+1 : 1;
            if(_count>0){
                $('.icon-bag').addClass('active');
            }
            $('#items_in_cart_count').html(_count);
            //$('.basket_button').attr('title','Products in cart - '+_count);
            $('.cart_bubble').addClass('active');
            setTimeout(function(){
               $('.cart_bubble').removeClass('active');
            }, 600); 
            return false;
        });
  
  		$('body').on('mouseenter mouseleave', '.shop_social .social_link', function(e) {
            $('.shop_social .social_link').not(this).stop(true).fadeTo('fast', e.type === 'mouseenter' ? 0.5 : 1);
        });

        $('.shopsocial_popupcont .popup_close').click(function(e){
          	$('.social_link[aria-expanded=true]').focus();
            $('.social_link').attr('aria-expanded', false);
            $('#shopify-section-header, .footer, .shop_social, #maincontent > div[class!="home_other_blocks"], .home_other_blocks > div[class!="popup_blocks"]').attr({'aria-hidden': false, 'tabindex': "0"});

            //$('.social_link[data-index='+(parseInt($(this).parents('.popup_container').find('.focus_simulation').val())+1)+']').trigger('focus');
        });
  
  
  
  
  		if($('.product_subscribe')[0]){
          var _availbl=new Date($('.product_subscribe').attr('data-date')); 
          var _ddt_now=new Date();
          var _is_availible=true;
          
          if(_availbl.getYear()>=_ddt_now.getYear()){
              if((_availbl.getMonth()<_ddt_now.getMonth() && _availbl.getYear()>_ddt_now.getYear()) || (_availbl.getMonth()>_ddt_now.getMonth() && _availbl.getYear()==_ddt_now.getYear())){
             	 _is_availible=false;
              }
          }
          
          if(_is_availible){
            $('.product_subscribe').hide();
            $('.pr_butons_wrapper').show();
          } else {
            var _mon_n = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
            $('.availible_ttl').html("AVAILABLE "+_mon_n[_availbl.getMonth()]+" "+(_availbl.getYear()+1900));
          }
        }

        $('.product_subscribe').click(function(e){
            e.preventDefault();
            $('.subs_popup .info_popup').addClass('opened').attr('aria-hidden', false);				
            $('body').addClass('y_hidden');			
            $('.subs_popup .loader_inner').css({'visibility':'hidden','opacity':'0'});
            $('.subs_popup .popup_container').addClass('opened');
            $('#sub_thankyou').hide();
            $('.subscription_form').show();
            $('.subs_popup .info_popup_inner span.enter_email').show();
            $('.subs_popup .info_popup_inner h2').show();
            $('#watch_subsrcibe').show();

            $('#subscr_coll').html($(this).attr('data-col'));
            $('#subscr_ttl').html($(this).attr('data-sku'));
            $('#watch_subsrcibe').attr('data-sku', $(this).attr('data-sku'));
        });


        $('body').on('click', '#watch_subsrcibe', function(e){
            var v = grecaptcha.getResponse();
            if(v.length != 0){
                $.validate({
                form: '.subscription_form', 
                scrollToTopOnError: false,
                onSuccess: function(){
                    if($('#subscription_email').val().trim().match(/[\d\w\-\_\.]+@[\d\w\-\_\.]+\.[\w]{2,4}/i)){
                       $('#watch_subsrcibe').hide();
                       $('.watch_subsrcibe_loading').show();
                       var _data={};
                       _data["form"]= "watchsubscribing";
                       _data["sku"]=$('#watch_subsrcibe').attr('data-sku').trim();
                       _data["email"]=$('#subscription_email').val().trim();
                       _data["collection"]=$('#collection_name').val().trim();
                      // _data["subscribe"]=($("#subscription_yes").prop('checked') ? 'Yes' : 'No');
                       _data["grecaptcha"]=$("#g-recaptcha-response").val();
                         PostRec('https://seiko-luxe.herokuapp.com/postrequest',_data, function(_err, ___data){
                               if(!_err){ 
                                    $('.checkbox_button').removeClass('checked').addClass('checked');
                                    $("#subscription_yes").prop('checked', true);
                                    $('#subscription_email').val('');
                               } else {
                                 console.log(_err);
                                 $('#sub_thankyou').html(_err.responseText);
                               }
                             $('#sub_thankyou').show();
                             $('.subscription_form').hide();
                             $('.subs_popup .info_popup_inner span.enter_email').hide();
                             $('.subs_popup .info_popup_inner h2').hide();
                             $('.watch_subsrcibe_loading').hide();
                         });	
                    }
                    return false;
                }
              });
            } else {
              return false;
            }
       });
});


function moveFocus(){
	$(document).find('.move').keydown(function(e){
      console.log(e.keyCode);
      if (e.keyCode == 39) {      
        $(this).next(".move").focus();
      }
      if (e.keyCode == 37) {      
        $(this).prev(".move").focus();
      }
    });
}


function openSocialPopup(__this){
  var index = __this.data('index');
  var img 	= __shop_social[index]['image'];
  var product = __shop_social[index];

  if($('.product_block_social').length>1)  _shop_social_corusel.flickity('destroy');

  __this.attr('aria-expanded', true);
  
  $('.products_list').empty();
  
  $('#shopify-section-header, .footer, .shop_social, #maincontent > div[class!="home_other_blocks"], .home_other_blocks > div[class!="popup_blocks"]').attr({'aria-hidden': true, 'tabindex': "-1"});
  
  

  __shop_social.map(function(_j,_o){
    if(_j['image']==img){
      var _np=_j['price'].split('.');
      if(parseInt(_np[1])>0){
        _np[0]=_j['price'];
      }

      var _z=_j['pimage'];
      var _neimg=_z.split('.');
      _neimg[_neimg.length-2]=_neimg[_neimg.length-2]+'_350x600';
      var _img=_neimg.join('.');
      
      $('.products_list').append('<div class="product_block_social carousel-cell" id="p_'+_o+'"><div class="product_block">'+   
                                 ($('.products_list').data('wishlist')=='yes' ? '<div data-handle="'+_j['handle']+'" class="wishlist" aria-label="adds product to wishlist" tabindex="0"></div>' : '')+
                                 '<div class="product_social_a">'+
                                 '<div onclick="location.href=\'/products/'+_j['handle']+'\'" class="product_image_block popup_product_image_block shadow_load" tabindex="0"><img src="'+$('.products_list').data('spin')+'" alt="'+_j['title']+'" title="'+_j['title']+'" class="spinner" data-src="'+_img+'" /></div>'+
                                 '<span class="product_name_price"><span class="npb">'+
                                 /*'<span class="popup_product_category"><img src="https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/prospex_logo_black.svg?582"></span>'+*/
                                 '<h2 class="product_name popup_product_name">'+_j['title']+'</h2>'+
                                 '<span class="product_price popup_product_price">$'+_np[0]+'</span>'+
                                 '<a class="standard_button" href="products/'+_j['handle']+'">VIEW DETAILS</a>'+
                                 '<a class="standard_button learn_more" href="pages/store-locator">STORE LOCATOR</a>'+
                                 '</span></span>'+
                                 '</div>'+
                                 //'<a href="/cart" class="standard_button white social_add_to_cart" data-id="'+_j['vid']+'" title="ADD TO CART" aria-label="adds product to cart">ADD TO CART</a>'+
                                 '</div></div>');
    }

  });
  
  if($('.product_block_social').length>1){
  	$('.products_list').attr('aria-roledescription', "carousel");
    $('.product_block_social').each(function(i){
      $(this).attr({'role': "group", 'aria-roledescription': "slide", 'aria-label': (i+1)+' of '+$('.product_block_social').length});
    });
  }

  if($('.product_block_social').length>1){
    _shop_social_corusel = $('.products_list').flickity({
      bgLazyLoad: true,
      wrapAround: true,
      //autoPlay: true,
      pauseAutoPlayOnHover: true
    });
    
    $('.popup_info_block .flickity-page-dots .dot').each(function(){
      $(this).attr({'aria-label': 'Slide '+($(this).index()+1)+ ' of '+($('.product_block_social').eq($(this).index()).find('.popup_product_name').html()), 'aria-controls': "Shopsocial-carousel-items", 'role': 'button'});
    });
  
  
    $('.popup_info_block .flickity-page-dots .dot').attr('tabindex', 0).addClass('move');
    _shop_social_corusel.on('cellSelect', function() {
      $('.popup_info_block .flickity-page-dots .dot').attr('aria-pressed', false);
      $('.popup_info_block .flickity-page-dots .dot.is-selected').addClass('move').attr('aria-pressed', true);
    });
    
    $('.popup_info_block .flickity-page-dots .dot').keydown(function(e) {
      var code = e.keyCode || e.which;
      if(code == 13) {
        var index = $(this).index();
        $('.popup_info_block .flickity-page-dots .dot').removeClass('is_selected');
        $(this).addClass('is_selected');
        _shop_social_corusel.flickity('select', index);
      }
    });
    
    
    
    $('.popup_info_block .flickity-page-dots .dot').focusin(function(e) {
        var index = $(this).index();
        $('.popup_info_block .flickity-page-dots .dot').removeClass('is_selected');
        $(this).addClass('is_selected');
        _shop_social_corusel.flickity('select', index);
    });
    
    
    $('.popup_info_block .popup_product_image_block, .popup_info_block .social_add_to_cart').focusin(function(e) {
        var index = $(this).parents('.product_block_social').index();
        _shop_social_corusel.flickity('select', index);
    });
  }
  
  if($('.popup_info_block .flickity-page-dots .dot').length){
    $('.popup_info_block .flickity-page-dots .dot').last().keydown(function(e) {
      var code = e.keyCode || e.which;
      if (!e.shiftKey && code == '9') {
        $('.shopsocial_popupcont .popup_close').focus();
        return false;
      }
    });
  }
  else{
    $('.popup_info_block .learn_more').last().keydown(function(e) {
      var code = e.keyCode || e.which;
      if (code == '9') {
        $('.shopsocial_popupcont .popup_close').focus();
        return false;
      }
    });
  }
  
  $('.shopsocial_popupcont .popup_close').last().keydown(function(e) {
    if (e.shiftKey && e.keyCode === 9) {
      return false;
    }
  });
  
  moveFocus();

  $('.popup_image_block').html('<img src="'+img+'" alt="'+product['title']+'" title="'+product['title']+'" />');

  // $('.popup_product_image_block').html('<img src="'+$('.popup_product_image_block').attr('data-spin')+'" alt="" title="" class="spinner" />');
  load_all_social_product_images();

  //$('.popup_product_name').html(product['title']);
  //	var _np=product['price'].split('.');
  //  if(parseInt(_np[1])>0){
  //		_np[0]=product['price'];
  //  }

  //$('.popup_product_price').html('$'+_np[0]);	

  //$('.popup_info_block').find('.wishlist').attr('data-handle',product['handle']);

  $('.shopsocial_popupcont').addClass('opened').attr('aria-hidden', 'false');				
  $('body').addClass('y_hidden');
  $('.loader_inner').css({'visibility':'visible','opacity':'1'});
  //$('.social_add_to_cart').attr('data-id',product['vid']);		
  //$('.social_add_to_cart').show();
  //$('.popup_info_block .product_url').attr('href', '/products/'+product['handle']);

  $(window).resize(function() {
    if(window.innerWidth < 768){
      var popup_other_width = $('.popup_image_block').width()-$('.popup_info_block .product_image_block').width();
      $('.popup_info_block .product_name_price').css('left', ($('.popup_info_block .product_image_block').width()+((popup_other_width-$('.popup_info_block .product_name_price').width())/2)));				
      $('.popup_info_block .standard_button').css('left', ($('.popup_info_block .product_image_block').width()+((popup_other_width-$('.popup_info_block .standard_button').width())/2-10)));		
    }
  }).trigger('resize');

  setTimeout(function(){				
    $('.loader_inner').css({'visibility':'hidden','opacity':'0'});
    $('.shopsocial_popupcont .popup_container').addClass('opened');
  }, 100);
  
  setTimeout(function(){
    //$('.focus_simulation').val(index).trigger('focus');
    $('.shopsocial_popupcont .popup_close').focus();
  }, 200);
}



function LoadShopSocialJSON(_url,_id, _cb){
  $.getJSON(_url, function(_socials ) {
    var _items=[];
    for(var _i=0;_i<_socials.length;_i++){
      if(_socials[_i].id.toString()==_id.toString()) {
        _items=_socials[_i].items;
        break;
      }
    } 
	_cb(_items);
  });
}
///////////////////////////////////////////////////
function ShopSocialCreate(_class){
  if(__shop_social.length>0){
    var _image_slides=[];
    var _ind=0;
    $('.shop_social.'+_class+' div[data-image="social"]').each(function(key, value){
      if(((_class=='home' && key<10) || (_class=='catalog' && key<7)) && __shop_social[_ind]){
           if(_image_slides.indexOf(__shop_social[_ind]['image'])!=-1){
              for(var _i=_ind;_i<__shop_social.length;_i++){
                if(_image_slides.indexOf(__shop_social[_i]['image'])==-1) {
                  _ind=_i;
                  break;
                }
              }
           }
            _image_slides.push(__shop_social[_ind]['image']);
            $(this).css({'background-image': 'url("'+__shop_social[_ind]['image_th']+'")'}).addClass('social_link').attr('role', 'button').attr('aria-expanded', 'false').attr('id', __shop_social[_ind]['pid']).attr('data-type', _class).attr('aria-label', 'Opens shop social popup for '+__shop_social[_ind]['title'] +' watch').attr('data-index', _ind);
              _ind++;
         
        }  else{
      	$(this).parents('.shop_social_block').hide();
      }
    }); 
  }
  else{
  	$('.shop_social').hide();
  }
  
}

function load_all_social_product_images(){
  $('.popup_product_image_block').each(function(){
    	 var _this=$(this);
    	 var _src=_this.find('.spinner').attr('data-src');
    	 var _title=_this.find('.spinner').attr('title');
 		 var img = new Image();
   		 img.src = _src;
   		 img.onload = function() {
           _this.html('<img src="'+_src+'" alt="'+_title+'" title="'+_title+'" class="imageforload" />').css('background-size', '100% 100%');
   		 }
  });
}


function Validate_file(_elem) {
    var _validFileExtensions = [".png",".jpg"];  
    var blnValid = false;
    var oInput = document.getElementById(_elem);
	if (oInput.type == "file") {
		var sFileName = oInput.value;
       var  fsize = Math.round((oInput.files.item(0).size / 1024));
		if (sFileName.length > 0) {		
			for (var j = 0; j < _validFileExtensions.length; j++) {
				var sCurExtension = _validFileExtensions[j];
				if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase() && fsize<=5120) {
					blnValid = true;
					break;
				}
			}		
		}
	}
    if(blnValid === false){
      $("#"+_elem).parents('label').addClass('has-error');
    }
    else{
      $("#"+_elem).parents('label').removeClass('has-error');
    }
    return blnValid;
}

function setPholder(){
  if(window.innerWidth > 480){
      if($('.pholder').length){
        $('.pholder').each(function(key, value){
          $(this).parent().find('input').css({'padding-top': 0, 'padding-left': ($(this).width()+25)});
        });
      }
    }
  else{
    if(window.innerWidth > 420){
      $('.form_block .pholder').parent().find('input').css({'padding-top': '12px', 'padding-left': '12px'});            
    }
    else{
      $('.form_block .pholder').parent().find('input').css({'padding-top': '11px', 'padding-left': '12px'});            
    }
  }
}

function loadImage(elem, _cb){
	var img = new Image();
  
  
    if(window.innerWidth < 480){
      if(elem.attr("data-srcm")){
        img.src = elem.attr("data-srcm");
      }
      else{
      	img.src = elem.attr("data-src");
      }
    }
    else{
      img.src = elem.attr("data-src");
    }
	
	img.onload = function() {
		elem.addClass('loaded');
		elem.css('background-image','url('+img.src+')');
		_cb();
	}
}
function loadAllBGImages(elems, _cb){
	if(elems.length>0){
		var _cont=elems.length;
		var _curr=0;
		elems.each(function(){
			loadImage($(this), function(){
				_curr++;
				if(_curr==_cont){
				 _cb(); 
				}
			});
		});
	} else {
		_cb();
	}
}

function loadShadowImage(elem){
	var img = new Image();
	img.src = elem.find('.product_image_block img').attr("src");
	
	img.onload = function() {
      setTimeout(function(){
      	elem.addClass('loaded');
		elem.find('.shadow_load').css('background-size', '100% 100%');	
      }, 200);			
	}
}

function parallax(bg, padding, step, position){
	var scrolled = $(window).scrollTop();
	if($('.'+bg).hasClass('carousel-bg')){
		$('.'+bg).css(position, (-(scrolled*step))+'px');
	} else{
		$('.'+bg).css(position, (-(scrolled*step)+padding)+'px');
	}
}

function parallax_blocks(_this, padding, step, position){
	var scrolled = $(window).scrollTop() - _this.parents('.parallax_height').offset().top + _this.parents('.parallax_height').innerHeight();	
  	_this.css(position, (-(scrolled*step)+padding)+'px');
}

function openNav($carousel, $this) {
	if($('.main_menu_inner').height() === 0){
      
      
      $('.main_menu_inner').attr('state', 'expanded').attr('aria-hidden', false);
      $('.main_menu_inner').find('a').attr('tabindex', 0);
      
      if(window.innerWidth>920){
        $('.menu_text_block').css('padding-top', ($('.menu_product_block').height()-$('.menu_text_block').height())/2);
      }
      else{
        //$('.menu_text_block').css({'padding-top': '20px', 'padding-bottom': '20px'});
		$('.menu_watches_block').scrollLeft( (600-window.innerWidth)/2 );
        $('body').css('overflow', 'hidden');
      }
      $this.addClass('open');
      $this.attr('aria-expanded', true);
      if($('.main_menu_mobile').height()>window.innerHeight){
        $('.main_menu_inner').height(window.innerHeight-$('.header').height());
        $('.main_menu_mobile').css('overflow-y', 'scroll');
      }else{
      	autoHeightAnimate($('.main_menu_inner'), 200);
      }
      $('.overlay').stop().animate({ 'z-index': '88', 'opacity': '1' }, 200);
      //$('body').addClass('openedmenu');
    } else {
      $('.main_menu_inner').attr('state', 'collapsed').attr('aria-hidden', true);
      $('.main_menu_inner').find('a').attr('tabindex', '-1');
      
      $('body').css('overflow', 'visible'); //.removeClass('openedmenu');;
      $this.removeClass('open');
      $this.attr('aria-expanded', false);
      $('.menu_button_collections').removeClass('open').attr('aria-expanded', false);
      $('.main_menu_inner').stop().animate({ height: '0' }, 200, function(){});
      $('.overlay').stop().animate({ 'z-index': '-1', 'opacity': '0' }, 200);
    }
  	
  	
}
///////////////////////////////////////////////////////////
function PostRec(_url, _data, callback){
	$.ajax({
		type: "POST",
		url: _url,
        dataType:'Json',
		data: _data
	}).done(function(o) {
		callback(null,o);
	}).fail(function(e) {
		callback(e);
	});
}

 
//////////////////////////////////////////////////////////////
function contentHeight(){
  
	if($('.content').height()<window.innerHeight - $('.header').innerHeight() - $('.footer').innerHeight()){
		$('.content').height(window.innerHeight - $('.header').innerHeight() - $('.footer').innerHeight());
	}
	else{
		$('.content').height('inherit');
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


function CreateFilters(){
    $.getJSON(_filters_json_url, function(_all_filters ) {
     
      	var _f_colors=_all_filters['colors'];
      	_f_colors.sort();
      	 _f_colors.map(function(_k){
     	       for(var _i=0;_i<_collection_tags.length;_i++){
                  if(_collection_tags[_i].tag.toString().toLowerCase()==_k.toString().toLowerCase()) {
                    $("#filter_color").append('<option value="'+_k.toString().toLowerCase()+'" '+(_collection_tags[_i].active ?  "selected" : '')+ '>'+_k.toString()+'</option>');
                    break;
                  }
               } 
		 });
      
       if($('#filter_color option').length==1){     
          $('#filter_color_cont').hide(); 
        }
      
        var _f_movements=_all_filters['movements'];
      	_f_movements.sort();
      
      	 _f_movements.map(function(_k){
     	       for(var _i=0;_i<_collection_tags.length;_i++){
                  if(_collection_tags[_i].tag.toString().toLowerCase()==_k.toString().toLowerCase()) {
                    $("#filter_movement").append('<option value="'+_k.toString().toLowerCase()+'" '+(_collection_tags[_i].active ?  "selected" : '')+ '>'+_k.toString()+'</option>');
                    break;
                  }
               } 
		 });
      
       if($('#filter_movement option').length==1){     
          $('#filter_movement_cont').hide(); 
        }

      
       var _f_materials=_all_filters['materials'];
      	_f_materials.sort();
    
      	_f_materials.map(function(_k){
     	       for(var _i=0;_i<_collection_tags.length;_i++){
                  if(_collection_tags[_i].tag.toString().toLowerCase()==_k.toString().toLowerCase()) {
                    $("#filter_material").append('<option value="'+_k.toString().toLowerCase()+'" '+(_collection_tags[_i].active ?  "selected" : '')+ '>'+_k.toString()+'</option>');
                    break;
                  }
               } 
		 });
      
       if($('#filter_material option').length==1){     
          $('#filter_material_cont').hide(); 
        }
      
      
      /*
      _all_filters['price_range'].map(function(_k){
     	       for(var _i=0;_i<_collection_tags.length;_i++){
                  if(_collection_tags[_i].tag.toString().toLowerCase()==_k.toString().toLowerCase()) {
                    $("#filter_price_range").append('<option value="'+_k.toString().toLowerCase()+'" '+(_collection_tags[_i].active ?  "selected" : '')+ '>'+_k.toString()+'</option>');
                    break;
                  }
               } 
		 });
      
       if($('#filter_price_range option').length==1){     
          $('#filter_price_range_cont').hide(); 
        }*/
      
      
      	 /*_all_filters['size'].map(function(_k){
     	       for(var _i=0;_i<_collection_tags.length;_i++){
                  if(_collection_tags[_i].tag.toString().toLowerCase()==_k.toString().toLowerCase()) {
                    $("#filter_size").append('<option value="'+_k.toString().toLowerCase()+'" '+(_collection_tags[_i].active ?  "selected" : '')+ '>'+_k.toString()+'</option>');
                    break;
                  }
               } 
		 });
      
       if($('#filter_size option').length==1){     
          $('#filter_size_cont').hide(); 
        }*/
      
      
      
          var _hashed_tags=window.location.hash.replace('#','').replace(/%20/g,' ');

          if(_hashed_tags!=""){
            var _tags=_hashed_tags.split('+');
            if($('#filter_color option').length>1){
              $("#filter_color option").each(function(){                
                   if(_tags.indexOf($(this).val())>-1)  $("#filter_color").val($(this).val()).change();
              });
            }
             if($('#filter_movement option').length>1){
                $("#filter_movement option").each(function(){                
                     if(_tags.indexOf($(this).val())>-1)  $("#filter_movement").val($(this).val()).change();
                });
              }
             if($('#filter_material option').length>1){
                $("#filter_material option").each(function(){                
                     if(_tags.indexOf($(this).val())>-1)  $("#filter_material").val($(this).val()).change();
                });
              }
            
            
            /*if($('#filter_price_range option').length>1){
                $("#filter_price_range option").each(function(){                
                     if(_tags.indexOf($(this).val())>-1)  $("#filter_price_range").val($(this).val()).change();
                });
              }*/
            
             /*if($('#filter_size option').length>1){
                $("#filter_size option").each(function(){                
                     if(_tags.indexOf($(this).val())>-1)  $("#filter_size").val($(this).val()).change();
                });
              }*/
          }

      
      
          $('.selectpicker').selectpicker('refresh');
      
      
		 if($('.product_item_for_filter').length==50){
            loadAllProducts();
         } else {
            StartFilter();
         }
    });
  }
////////////////////////////////////////////////////////////////////////////

function loadAllProducts(){
	var _url= window.location.href.split('#')[0];
    $.ajax({	
        url: _url+(_url.indexOf('?')>0 ? '&' : '/?')+'page='+_ajaxloadingpageid,
        type: 'get',
      	dataType:'html', 
        success: function(response){
          var result = $(response).find('.product_block_margin');
		  var _prds=$(result).find('.product_item_for_filter');
          if(_prds.length>0){
            
				_prds.each(function(){      
					$('.product_block_margin').append($(this));
				});
            	
				
				if(_prds.length==50){
				  _ajaxloadingpageid++;
				  loadAllProducts();
				} else {	
				   StartFilter();
				}
          } else {
               StartFilter();
          }
        }
      }); 

  
}

////////////////////////////////////////////////////////////////////////////

function StartFilter(){
  
   if($('.product_item_for_filter').length>0){
		var _tags=[];
        var _tags_color=[];
        var _tags_material=[];
        var _tags_movement=[];
        //var _tags_size=[];
     	//var _tags_price_range=[];
        
        
            if($('#filter_color option').length>1 &&  $("#filter_color").val()!="0"  &&  $("#filter_color").val()!=null){
               _tags.push($("#filter_color").val());
               _tags_color.push($("#filter_color").val());
            }
            if($('#filter_movement option').length>1 &&  $("#filter_movement").val()!="0" &&  $("#filter_movement").val()!=null){
               _tags.push($("#filter_movement").val());
               _tags_movement.push($("#filter_movement").val());
            }
          if($('#filter_material option').length>1 &&  $("#filter_material").val()!="0" &&  $("#filter_material").val()!=null){
               _tags.push($("#filter_material").val());
               _tags_material.push($("#filter_material").val());
            }
     		/*if($('#filter_price_range option').length>1 &&  $("#filter_price_range").val()!="0"  &&  $("#filter_price_range").val()!=null){
               _tags.push($("#filter_price_range").val());
               _tags_price_range.push($("#filter_price_range").val());
            }*/
         /*if($('#filter_size option').length>1 &&  $("#filter_size").val()!="0"  &&  $("#filter_size").val()!=null){
               _tags.push($("#filter_size").val());
               _tags_size.push($("#filter_size").val());
            }*/
            
      
        if(!$('.search_page_content')[0]){
            var _url=window.location.origin+'/collections/'+_collection_handle;


            if(_tags.length>0) {
              _url=_url+'#'+_tags.join('+');
              //$('#resetfilterbtn').show(); 
              $('#resetfilterbtn a').css({'pointer-events': 'inherit', color: '#204072'});
            } else {
              //$('#resetfilterbtn').hide(); 
              if(window.innerWidth <= 640){
              	$('#resetfilterbtn a').css({'pointer-events': 'none', color: '#efefef'});
              }
              else{
              	$('#resetfilterbtn a').css({'pointer-events': 'none', color: '#fff'});
              }
            }

            //history.pushState({}, '', _url); 
        }
        var _countp=0;
     
     

       	$('.product_item_for_filter').removeClass('p_show').addClass('p_hide');
        for(var _i=0; _i<$('.product_item_for_filter').length;_i++){
          	 var _this=$('.product_item_for_filter')[_i];
          
          	if(_tags.length>0){
                 var _inds=0;
                if(_tags_color.length>0){
                      for(var _j=0; _j<_tags_color.length;_j++){
                        for(var _k=0; _k<_tags_color[_j].length;_k++){
                          if($(_this).attr('data-filters').toLowerCase().indexOf('|'+_tags_color[_j][_k].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                        }
                      }
                } else {
                  _inds++;
                }
             	 if(_tags_material.length>0){
                      for(var _j=0; _j<_tags_material.length;_j++){
                        for(var _k=0; _k<_tags_material[_j].length;_k++){
                          if($(_this).attr('data-filters').toLowerCase().indexOf('|'+_tags_material[_j][_k].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                        }
                      }
                } else {
                  _inds++;
                }
               if(_tags_movement.length>0){
                      for(var _j=0; _j<_tags_movement.length;_j++){
                        for(var _k=0; _k<_tags_movement[_j].length;_k++){
                          if($(_this).attr('data-filters').toLowerCase().indexOf('|'+_tags_movement[_j][_k].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                        }
                      }
                } else {
                  _inds++;
                }
              
              
              
              /*if(_tags_price_range.length>0){
                      for(var _j=0; _j<_tags_price_range.length;_j++){
                        for(var _k=0; _k<_tags_price_range[_j].length;_k++){
                          if($(_this).attr('data-filters').toLowerCase().indexOf('|'+_tags_price_range[_j][_k].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                        }
                      }
                } else {
                  _inds++;
                }*/
              
              
              /*if(_tags_size.length>0){
                      for(var _j=0; _j<_tags_size.length;_j++){
                        for(var _k=0; _k<_tags_size[_j].length;_k++){
                          if($(_this).attr('data-filters').toLowerCase().indexOf('|'+_tags_size[_j][_k].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                        }
                      }
                } else {
                  _inds++;
                }*/
             
               if(_inds==3) {
               	   $(_this).removeClass('p_hide').addClass('p_show');
                   if(!$(_this).find('.product_image_block_img').hasClass('loaded')){
                   		 $(_this).find('.product_image_block_img').attr('src',  $(_this).find('.product_image_block_img').attr('data-src')).addClass('loaded');
                   }
                 _countp++;
               }
            } else {    
              	$(_this).removeClass('p_hide').addClass('p_show');
                if(!$(_this).find('.product_image_block_img').hasClass('loaded')){
                  $(_this).find('.product_image_block_img').attr('src',  $(_this).find('.product_image_block_img').attr('data-src')).addClass('loaded');
                }
                _countp++;
            }
          
            if($('.shadow_load').length){
               loadShadowImage($(_this));
            }

          	if(_countp==20)  break;
         
         }
        	
        if(_countp==0){
          $('.no_products').show();
        }
        else{
          $('.no_products').hide();
        }
  
        $('.loadmore').hide();
        _loadingcollectionproducts=false;
        
     	
      }
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function NexstFilteredList(){

      if(_productslistshow*20<=$('.product_item_for_filter').length){
        _productslistshow++;
		var _tags=[];
        var _tags_color=[];
        var _tags_material=[];
        var _tags_movement=[];
        //var _tags_size=[];
        //var _tags_price_range=[];
        
        
            if($('#filter_color option').length>1 &&  $("#filter_color").val()!="0" &&  $("#filter_color").val()!=null){
               _tags.push($("#filter_color").val());
               _tags_color.push($("#filter_color").val());
            }
            if($('#filter_movement option').length>1 &&  $("#filter_movement").val()!="0" &&  $("#filter_movement").val()!=null){
               _tags.push($("#filter_movement").val());
               _tags_movement.push($("#filter_movement").val());
            }
          	if($('#filter_material option').length>1 &&  $("#filter_material").val()!="0" &&  $("#filter_material").val()!=null){
               _tags.push($("#filter_material").val());
               _tags_material.push($("#filter_material").val());
            }
        
        	/*if($('#filter_price_range option').length>1 &&  $("#filter_price_range").val()!="0" &&  $("#filter_price_range").val()!=null){
               _tags.push($("#filter_price_range").val());
               _tags_price_range.push($("#filter_price_range").val());
            }*/
        
         /*if($('#filter_size option').length>1 &&  $("#filter_size").val()!="0" &&  $("#filter_size").val()!=null){
               _tags.push($("#filter_size").val());
               _tags_size.push($("#filter_size").val());
            }*/
     	
        var _countp=0;

        for(var _i=((_productslistshow-1)*20); _i<$('.product_item_for_filter').length;_i++){
           	var _this=$('.product_item_for_filter')[_i];
        	if(_tags.length>0){
          		var _inds=0;
               if(_tags_color.length>0){
                      for(var _j=0; _j<_tags_color.length;_j++){
                        for(var _k=0; _k<_tags_color[_j].length;_k++){
                          if($(_this).attr('data-filters').toLowerCase().indexOf('|'+_tags_color[_j][_k].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                        }
                      }
                } else {
                  _inds++;
                }
             	 if(_tags_material.length>0){
                      for(var _j=0; _j<_tags_material.length;_j++){
                        for(var _k=0; _k<_tags_material[_j].length;_k++){
                          if($(_this).attr('data-filters').toLowerCase().indexOf('|'+_tags_material[_j][_k].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                        }
                      }
                } else {
                  _inds++;
                }
               if(_tags_movement.length>0){
                      for(var _j=0; _j<_tags_movement.length;_j++){
                        for(var _k=0; _k<_tags_movement[_j].length;_k++){
                          if($(_this).attr('data-filters').toLowerCase().indexOf('|'+_tags_movement[_j][_k].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                        }
                      }
                } else {
                  _inds++;
                }
              
              /*if(_tags_price_range.length>0){
                      for(var _j=0; _j<_tags_price_range.length;_j++){
                        for(var _k=0; _k<_tags_price_range[_j].length;_k++){
                          if($(_this).attr('data-filters').toLowerCase().indexOf('|'+_tags_price_range[_j][_k].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                        }
                      }
                } else {
                  _inds++;
                }*/
              
              
              /*if(_tags_size.length>0){
                      for(var _j=0; _j<_tags_size.length;_j++){
                        for(var _k=0; _k<_tags_size[_j].length;_k++){
                          if($(_this).attr('data-filters').toLowerCase().indexOf('|'+_tags_size[_j][_k].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                        }
                      }
                } else {
                  _inds++;
                }*/

               if(_inds==3) {
               	   $(_this).removeClass('p_hide').addClass('p_show');
                   if(!$(_this).find('.product_image_block_img').hasClass('loaded')){
                   		 $(_this).find('.product_image_block_img').attr('src',  $(_this).find('.product_image_block_img').attr('data-src')).addClass('loaded');
                   }
                 _countp++;
               }
            }else{
              $(_this).removeClass('p_hide').addClass('p_show');
              if(! $(_this).find('.product_image_block_img').hasClass('loaded')){
                $(_this).find('.product_image_block_img').attr('src',  $(_this).find('.product_image_block_img').attr('data-src')).addClass('loaded');
              }
              _countp++;
            }
          
          	if($('.shadow_load').length){
               loadShadowImage($(_this));
            }
          
        	if(_countp==20*_productslistshow)  break;
         }
        _loadingcollectionproducts=false;
        
      }

}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////
var _whitelist_ips=['10.200.113.151','118.238.253.139','212.73.90.161'];
function CheckCountry(){
  if(!seiko_readCookie()) {
 	 var xhttp=new XMLHttpRequest;
        xhttp.onreadystatechange=function() {
            if(4===this.readyState&&200===this.status) {
                var t=JSON.parse(this.responseText);
                if(t.code!="SX" && t.code!="MF" && t.code!="KY" && t.code!="KN" && t.code!="JM" && t.code!="AW" && t.code!="US" && t.code!="CA" && t.code!="RO" && t.code!="AM" &&  _whitelist_ips.indexOf(t.ip.toString())==-1) location.href='https://www.seikowatches.com/';
            }
        }
        ,
        xhttp.open("GET", "https://appdevelopergroup.co/geoip.php", !0),
        xhttp.send();
  }
}

//////////////////////////////////////////////////////
function seiko_readCookie() {
  if(window.location.hash.substring(1)=="addtoadminacc"){
  	  var o=new Date;
 	  o.setTime(o.getTime()+360*24*60*60*1000);
 	  document.cookie="admin_login_success=seikousaadmin; expires="+o.toGMTString()+"; path=/";
     return true;
  } else {
        for(var t="admin_login_success=", n=document.cookie.split(";"), o=0; o<n.length; o++) {
            for(var r=n[o];" "==r.charAt(0);)r=r.substring(1, r.length);
            if(0==r.indexOf(t)) {
              if(GMMD5.MD5(GMMD5.MD5('3')+GMMD5.MD5(r.substring(t.length, r.length)))=="4b72a03fdefd70888f6eb2e7080b9797")  return true;
            }
        }
        return false;
  }
 }
////////////////////////////////////////////////////////////////////////////

function loadPressNextPage(){
    
  	_canayaxload=false;
	var _url= window.location.href.split('#')[0];
    $.ajax({	
        url: _url+(_url.indexOf('?')>0 ? '&' : '/?')+'page='+_ajaxloadpresspage,
        type: 'get',
      	dataType:'html', 
        success: function(response){
          var result = $(response).find('.press_grid');
		  var _artk=$(result).find('.grid-item').addClass('hidden_grid');
          if(_artk.length>0){
            $('.loader_blog').css({'visibility':'visible','opacity':'1'});
            
				_artk.each(function(){
                       
					   $('.press_grid').append($(this));
                  
                  	   $('.press_grid').masonry( 'appended', $(this), true ); 
                       window.setTimeout(function() {
                            $('.press_grid').masonry('layout');
                       }, 60);
                  
                  	   window.setTimeout(function() {
                         $('.grid-item').removeClass('hidden_grid');
                       }, 50);
				});
            	setTimeout(function(){ _canayaxload=true;},100);
            
				if(_artk.length==150){
				  _ajaxloadpresspage=-1;
				} else {	
				   _ajaxloadpresspage++;
				}
            
            $('.loader_blog').css({'visibility':'hidden','opacity':'0'});
          } 
        }
      }); 

}



//////////////////////////////////////////////////////////////////////////
var _collections_list_for_store_locator=[
  [],
  ["presage","studio-ghibli-porco-rosso-limited-edition","enamel-dial-automatic","arita","shippo-enamel-limited-edition","the-urushi-byakudan-nuri-limited-edition","presage-enamel"], 
  ["prospex","the-1968-automatic-diver-s-re-creations","the-1970-diver-s-re-creation-limited-edition"],
  ["prospex-lx"],
  ["astron"]
];



function get_all_addresses_popup(_data){
  var _allpr=[];
  var _ind=0;
  _data.map(function(_k,_c){
    if(_ind<3 && (_k.display_name.indexOf(', USA')>0 || _k.display_name.indexOf(', Guam')>0 || _k.display_name.indexOf(', United States')>0)){
      var _address=_k.display_name.replace(/, United States of America/g,'');
      if(_address.indexOf('County')>0){
        var _tmm=_address.split(',');
        var _new_addr=[];
        _tmm.map(function(_t){
          if(_t.indexOf('County')==-1) _new_addr.push(_t.trim());
        });
        _address=_new_addr.join(', ');
      }
    	_allpr.push({"id":_c+2, "title":_address, "lat":_k.lat, "lon":_k.lon});
      _ind++;
    }
  });
  return _allpr;
}

function searchLocations_inpopup() {
   $(".l_map_res_list").empty();
   $('.list_loader_popup').show();
	var address =($('#praddress_incollection').val().length>0 ? $('#praddress_incollection').val().trim().replace(/ /g,'+')+'+' : "");
		
	if(address.length>2){
		$.getJSON('https://nominatim.openstreetmap.org/search?q='+address+'&format=json&polygon=1&addressdetails=1', function(_locs) {    
		if (_locs) {
			if (_locs[0]) {
				searchLocationsNear_popup(parseFloat(_locs[0].lat),parseFloat(_locs[0].lon));
			} else {
                $('.list_loader_popup').hide();
				PopuperShow("No locations were found using address.");
			}
		} else {
            $('.list_loader_popup').hide();
			PopuperShow("No locations were found using address.");
		}
		});
	}else{
       $('.list_loader_popup').hide();
		PopuperShow("Please enter an address.");
	}
	return false;
}


function searchLocationsNear_popup(lat, lng) {
  	_curr_lat=lat;
 	_curr_lng=lng;
	var searchUrl = 'https://seiko-luxe.herokuapp.com/postrequest/';
	var _data={};
    _data["latitude"]   = lat;
    _data["longitude"]  = lng;
  //console.log(_collection_handle);
  var _other_coll=true;
  var _curr_coll=-1;
  if(typeof _collection_handle !='undefined'){
    if(_collection_handle!=''){
      for(var _u=0;_u<_collections_list_for_store_locator.length;_u++){
        if(_collections_list_for_store_locator[_u].indexOf(_collection_handle)>-1) {
          _other_coll=false;
          _curr_coll=_u;
          _data["collection"]=_curr_coll;
          break;
        }
      }
    }
  }
  
  	
	
	PostRec(searchUrl, _data, function(_err, __data){
   	    if(!_err){
   	    	___data = __data['stores'];
          
          	var _itmss=[];
           $('.list_loader_popup').hide();
   	    	if(___data.length>0){
	   	    	for (var i = 0; i < ___data.length; i++) {
                  if(_other_coll || (!_other_coll && ___data[i].collections.indexOf(_curr_coll)>-1)){
                    _itmss.push({id:___data[i]._id,name:___data[i].data.name, address:___data[i].data.city_state,latl:___data[i].position[1],lngl:___data[i].position[0],distance:getDistance_popup(lat, lng, ___data[i].position[1], ___data[i].position[0]).toFixed(1)}); 
                  }
				}
              if(_itmss.length>0){
                _itmss.sort(function (a, b) {
                    if (a.distance > b.distance) {
                      return 1;
                    }
                    if (a.distance < b.distance) {
                      return -1;
                    }
                    return 0;
                  });
                
                  if(window.innerWidth > 640){
                    for (var i = 0; i < _itmss.length; i++) {
                         createOption_popup(_itmss[i].id,_itmss[i].name,  _itmss[i].address, _itmss[i].latl, _itmss[i].lngl, _itmss[i].distance, i);
                      	if(i==2) break;
                    }  
                  }
                  else{
					for (var i = 0; i < _itmss.length; i++) {
                         createOption_popup(_itmss[i].id,_itmss[i].name,  _itmss[i].address, _itmss[i].latl, _itmss[i].lngl, _itmss[i].distance, i);
                        if(i==1) break;
                    }  
                  }
                  $(".l_map_res_list").append('<a class="view_more_s" href="/pages/store-locator#'+_itmss[0].id+"|"+_curr_lat+"|"+_curr_lng+'">View all results</a>');
                
             	 var ul_height = $('.find_a_store_opened .l_map_res_list').height();
             	 $('.find_a_store_opened').stop().animate({"height": ul_height+190}, 400);
             	 $('.find_a_store_opened .l_map_wrap_left_scrl').stop().animate({"height": ul_height}, 400);
              } else{
                  $('.find_a_store_opened').stop().animate({"height": 200}, 400);
                  PopuperShow("There are no stores near your entered location.  Please try another input address to search for locations.");	
              }
			} else{
                $('.find_a_store_opened').stop().animate({"height": 200}, 400);
				PopuperShow("There are no stores near your entered location.  Please try another input address to search for locations.");	
			}
		} 
		
     });	
}

function createOption_popup(id, store_name,  address, lat, lng, distance, i) {	
  	PopuperClose();
  	$('.store_popup_block h2 span').hide();
	$(".l_map_res_list").append(
      "<li class='l_map_res_list_i' tabindex='0' data-id='"+i+"'  "+
          "data-name='"+store_name.trim()+"' " +
          "data-address='"+address.trim()+"' " +

          "data-lat='"+lat+"' data-lng='"+lng+"'> " +
          "<a href='/pages/store-locator#"+id+"|"+_curr_lat+"|"+_curr_lng+"'><span class='l_map_store_name'>" + store_name.trim() + "</span>" +
          "<p class='l_map_distance'>" + distance +" mi<span class='l_map_address'>" + address.trim()+"</span></p>" +
          "</a>" +
      "</li>");
}


function getDistance_popup(lat1,lon1,lat2,lon2) {
  var R = 3963.1676; // Radius of the earth in miles
  var dLat = deg2rad_popup(lat2-lat1);  // deg2rad below
  var dLon = deg2rad_popup(lon2-lon1); 
  var a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad_popup(lat1)) * Math.cos(deg2rad_popup(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c; // Distance in miles
  return d;
}

function deg2rad_popup(deg) {
  return deg * (Math.PI/180)
}


function L_GeoIP_popup(){
  $.getJSON("https://geoip-db.com/json/").success(function(data) {
    if(data.country_code!="US"){
        PopuperShow("No locations were found using your search criteria [ <b>"+(data.country_name || 'Your location')+"</b> ]. Please try another input address to search for locations."); 
    } else{
       $('.list_loader_popup').show();
       searchLocationsNear_popup(parseFloat(data.latitude),parseFloat(data.longitude));
    }
  }).error(function() {
      PopuperShow("No locations were found using your search criteria [Your location]. Please try another input address to search for locations."); 
  });
}


function PopuperShow(test) {
  $('.store_popup_block h2 span').show();
  $('#l_map_wrap_m_text').animate({ opacity: 0, height: 0 }, 300, function(){
    if(window.innerWidth > 640){
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '70px' }, 600);
      	$('.find_a_store_opened').stop().animate({"height": 260}, 400);
    }
    else{
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '60px' }, 600);	
    }
  });
  
  setTimeout(function(){
  	$('#l_map_wrap_m_text').animate({ opacity: 0, height: 0 }, 600);
  }, 3000);
}
       
function PopuperClose(test) {	
  $('#l_map_wrap_m_text').html(test).animate({ opacity: 0, height: 0 }, 600);	
}
